/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import { getOverrideProps } from "./utils";
import { Flex, Icon, Text, View } from "@aws-amplify/ui-react";
export default function EveryoneAgrees(props) {
  const { overrides, ...rest } = props;
  return (
    <Flex
      gap="10px"
      direction="column"
      width="1440px"
      height="665px"
      justifyContent="center"
      alignItems="center"
      position="relative"
      padding="71px 68px 71px 68px"
      backgroundColor="rgba(248,248,248,1)"
      {...getOverrideProps(overrides, "EveryoneAgrees")}
      {...rest}
    >
      <Flex
        gap="114px"
        direction="row"
        width="unset"
        height="unset"
        justifyContent="flex-start"
        alignItems="center"
        shrink="0"
        position="relative"
        padding="0px 0px 0px 0px"
        {...getOverrideProps(overrides, "Frame 1160464790")}
      >
        <Flex
          padding="0px 0px 0px 0px"
          width="502.7px"
          height="522px"
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          shrink="0"
          position="relative"
          {...getOverrideProps(overrides, "Group 1160463944")}
        >
          <View
            width="189px"
            height="195px"
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            overflow="hidden"
            position="absolute"
            top="327px"
            left="0px"
            border="1px SOLID rgba(225,225,225,1)"
            borderRadius="8px"
            padding="0px 0px 0px 0px"
            backgroundColor="rgba(255,255,255,1)"
            {...getOverrideProps(overrides, "389 3")}
          >
            <Icon
              width="244.82px"
              height="163.22px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 244.82278442382812,
                height: 163.21519470214844,
              }}
              paths={[]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="0%"
              bottom="16.3%"
              left="0%"
              right="-29.54%"
              {...getOverrideProps(overrides, "Vector753723981")}
            ></Icon>
            <Icon
              width="30.35px"
              height="22.09px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 30.35285758972168,
                height: 22.09178924560547,
              }}
              paths={[
                {
                  d: "M9.9515 19.7567C18.331 24.7791 30.3529 20.1365 30.3529 20.1365C30.3529 20.1365 28.7808 7.35291 20.3965 2.33649C12.0167 -2.68564 0 1.9513 0 1.9513C0 1.9513 1.57176 14.7346 9.9515 19.7567Z",
                  fillRule: "nonzero",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="58.04%"
              bottom="30.63%"
              left="13.52%"
              right="70.42%"
              {...getOverrideProps(overrides, "Vector753723982")}
            ></Icon>
            <Icon
              width="7px"
              height="7px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 7.003564834594727,
                height: 7.0035600662231445,
              }}
              paths={[
                {
                  d: "M3.50178 7.00356C5.43576 7.00356 7.00357 5.43576 7.00357 3.50178C7.00357 1.5678 5.43576 0 3.50178 0C1.5678 0 0 1.5678 0 3.50178C0 5.43576 1.5678 7.00356 3.50178 7.00356Z",
                  fill: "rgba(179,179,179,1)",
                  fillRule: "nonzero",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="28.33%"
              bottom="68.08%"
              left="50.91%"
              right="45.38%"
              transformOrigin="top left"
              transform="rotate(180deg)"
              {...getOverrideProps(overrides, "Vector753723983")}
            ></Icon>
            <Icon
              width="7.88px"
              height="7.88px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 7.878946781158447,
                height: 7.878946781158447,
              }}
              paths={[
                {
                  d: "M3.93947 7.87895C6.11518 7.87895 7.87895 6.11519 7.87895 3.93948C7.87895 1.76377 6.11518 0 3.93947 0C1.76376 0 0 1.76377 0 3.93948C0 6.11519 1.76376 7.87895 3.93947 7.87895Z",
                  fill: "rgba(179,179,179,1)",
                  fillRule: "nonzero",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="40.26%"
              bottom="55.7%"
              left="40.35%"
              right="55.48%"
              transformOrigin="top left"
              transform="rotate(180deg)"
              {...getOverrideProps(overrides, "Vector753723984")}
            ></Icon>
            <Icon
              width="3.94px"
              height="3.94px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 3.9394707679748535,
                height: 3.9394707679748535,
              }}
              paths={[
                {
                  d: "M1.96974 3.93947C3.05759 3.93947 3.93947 3.05759 3.93947 1.96974C3.93947 0.881881 3.05759 0 1.96974 0C0.881881 0 0 0.881881 0 1.96974C0 3.05759 0.881881 3.93947 1.96974 3.93947Z",
                  fill: "rgba(225,228,229,1)",
                  fillRule: "nonzero",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="69.17%"
              bottom="28.81%"
              left="97.88%"
              right="0.04%"
              transformOrigin="top left"
              transform="rotate(180deg)"
              {...getOverrideProps(overrides, "Vector753723985")}
            ></Icon>
            <Icon
              width="5.69px"
              height="5.69px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 5.690225601196289,
                height: 5.690225601196289,
              }}
              paths={[
                {
                  d: "M2.84511 5.69023C4.41643 5.69023 5.69023 4.41643 5.69023 2.84511C5.69023 1.2738 4.41643 0 2.84511 0C1.2738 0 0 1.2738 0 2.84511C0 4.41643 1.2738 5.69023 2.84511 5.69023Z",
                  fill: "rgba(225,228,229,1)",
                  fillRule: "nonzero",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="58.23%"
              bottom="38.85%"
              left="25.49%"
              right="71.5%"
              transformOrigin="top left"
              transform="rotate(180deg)"
              {...getOverrideProps(overrides, "Vector753723986")}
            ></Icon>
            <Icon
              width="4.33px"
              height="4.33px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 4.330643177032471,
                height: 4.330643177032471,
              }}
              paths={[
                {
                  d: "M2.16532 4.33064C3.3612 4.33064 4.33064 3.3612 4.33064 2.16532C4.33064 0.969447 3.3612 0 2.16532 0C0.969447 0 0 0.969447 0 2.16532C0 3.3612 0.969447 4.33064 2.16532 4.33064Z",
                  fill: "rgba(225,228,229,1)",
                  fillRule: "nonzero",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="44.21%"
              bottom="53.57%"
              left="49.47%"
              right="48.24%"
              transformOrigin="top left"
              transform="rotate(180deg)"
              {...getOverrideProps(overrides, "Vector753723987")}
            ></Icon>
            <Icon
              width="4.81px"
              height="4.81px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 4.814847946166992,
                height: 4.814847946166992,
              }}
              paths={[
                {
                  d: "M2.40742 4.81485C3.73701 4.81485 4.81485 3.73701 4.81485 2.40742C4.81485 1.07784 3.73701 0 2.40742 0C1.07784 0 0 1.07784 0 2.40742C0 3.73701 1.07784 4.81485 2.40742 4.81485Z",
                  fill: "rgba(225,228,229,1)",
                  fillRule: "nonzero",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="16.91%"
              bottom="80.62%"
              left="93.92%"
              right="3.54%"
              transformOrigin="top left"
              transform="rotate(180deg)"
              {...getOverrideProps(overrides, "Vector753723988")}
            ></Icon>
            <Icon
              width="4.32px"
              height="4.32px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 5.295270426580828,
                height: 5.295270426584466,
              }}
              paths={[
                {
                  d: "M2.16179 4.32357C3.35571 4.32357 4.32357 3.35571 4.32357 2.16179C4.32357 0.967864 3.35571 0 2.16179 0C0.967864 0 0 0.967864 0 2.16179C0 3.35571 0.967864 4.32357 2.16179 4.32357Z",
                  fill: "rgba(225,228,229,1)",
                  fillRule: "nonzero",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="30.19%"
              bottom="67.59%"
              left="36.85%"
              right="60.87%"
              transformOrigin="top left"
              transform="rotate(75deg)"
              {...getOverrideProps(overrides, "Vector753723989")}
            ></Icon>
            <Icon
              width="5.75px"
              height="5.75px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 5.751703262329102,
                height: 5.751703262329102,
              }}
              paths={[
                {
                  d: "M2.87585 5.7517C4.46414 5.7517 5.7517 4.46414 5.7517 2.87585C5.7517 1.28756 4.46414 0 2.87585 0C1.28756 0 0 1.28756 0 2.87585C0 4.46414 1.28756 5.7517 2.87585 5.7517Z",
                  fill: "rgba(225,228,229,1)",
                  fillRule: "nonzero",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="12.39%"
              bottom="84.66%"
              left="61.12%"
              right="35.84%"
              transformOrigin="top left"
              transform="rotate(180deg)"
              {...getOverrideProps(overrides, "Vector753723990")}
            ></Icon>
            <Icon
              width="4.42px"
              height="3.54px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 4.4247636795043945,
                height: 3.53959321975708,
              }}
              paths={[
                {
                  d: "M2.21238 3.53959C3.43425 3.53959 4.42476 2.74723 4.42476 1.7698C4.42476 0.792365 3.43425 0 2.21238 0C0.990517 0 0 0.792365 0 1.7698C0 2.74723 0.990517 3.53959 2.21238 3.53959Z",
                  fill: "rgba(225,228,229,1)",
                  fillRule: "nonzero",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="49.89%"
              bottom="48.3%"
              left="106.18%"
              right="-8.52%"
              transformOrigin="top left"
              transform="rotate(180deg)"
              {...getOverrideProps(overrides, "Vector753723991")}
            ></Icon>
            <Icon
              width="9px"
              height="9px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 11.020986735878978,
                height: 11.020986735878978,
              }}
              paths={[
                {
                  d: "M4.4993 8.9986C6.98419 8.9986 8.9986 6.98419 8.9986 4.4993C8.9986 2.01441 6.98419 0 4.4993 0C2.01441 0 0 2.01441 0 4.4993C0 6.98419 2.01441 8.9986 4.4993 8.9986Z",
                  fill: "rgba(225,228,229,1)",
                  fillRule: "nonzero",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="22.03%"
              bottom="73.36%"
              left="77.52%"
              right="17.72%"
              transformOrigin="top left"
              transform="rotate(75deg)"
              {...getOverrideProps(overrides, "Vector753723992")}
            ></Icon>
            <Icon
              width="152.98px"
              height="56.82px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 152.975341796875,
                height: 56.817386627197266,
              }}
              paths={[
                {
                  d: "M148.964 0L149.021 0C149.364 4.85592 152.975 4.93046 152.975 4.93046C152.975 4.93046 148.993 5.00826 148.993 10.619C148.993 5.00826 145.011 4.93046 145.011 4.93046C145.011 4.93046 148.621 4.85592 148.964 0ZM3.50695 47.2065L3.55837 47.2065C3.86249 51.6013 7.06667 51.669 7.06667 51.669C7.06667 51.669 3.53334 51.7392 3.53334 56.8174C3.53334 51.7392 0 51.669 0 51.669C0 51.669 3.20282 51.6013 3.50695 47.2065Z",
                  fill: "rgba(225,228,229,1)",
                  fillRule: "nonzero",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="44.53%"
              bottom="26.34%"
              left="35.07%"
              right="-16.01%"
              {...getOverrideProps(overrides, "Vector753723993")}
            ></Icon>
            <Icon
              width="36.93px"
              height="36.93px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 36.92964172363281,
                height: 36.92985534667969,
              }}
              paths={[
                {
                  d: "M0.000245159 18.3247L-4.21604 18.2926L-4.21609 18.303L0.000245159 18.3247ZM18.5581 0.000240544L18.5795 -4.2161L18.5794 -4.2161L18.5581 0.000240544ZM18.4653 36.9299L18.4552 41.1462L18.4653 41.1462L18.4653 36.9299ZM4.21652 18.3568C4.27634 10.5019 10.6818 4.17691 18.5368 4.21658L18.5794 -4.2161C6.07545 -4.27925 -4.1208 5.78909 -4.21603 18.2926L4.21652 18.3568ZM18.5367 4.21658C26.3918 4.25646 32.7329 10.6458 32.7132 18.5007L41.146 18.5219C41.1774 6.0179 31.0832 -4.15261 18.5795 -4.2161L18.5367 4.21658ZM32.7132 18.5007C32.6935 26.3558 26.3201 32.7135 18.4653 32.7135L18.4653 41.1462C30.9695 41.1462 41.1146 31.0257 41.146 18.5219L32.7132 18.5007ZM18.4755 32.7135C16.5952 32.7089 14.7342 32.3334 12.9992 31.6085L9.74801 39.3893C12.5066 40.542 15.4655 41.139 18.4552 41.1462L18.4755 32.7135ZM12.9992 31.6085C11.2642 30.8835 9.68933 29.8234 8.36476 28.4888L2.37939 34.4291C4.48542 36.5511 6.98945 38.2367 9.74801 39.3893L12.9992 31.6085ZM8.36476 28.4888C7.04019 27.1541 5.99197 25.5713 5.28015 23.8309L-2.52505 27.0232C-1.39328 29.7904 0.273355 32.307 2.37939 34.4291L8.36476 28.4888ZM5.28015 23.8309C4.56833 22.0905 4.2069 20.2267 4.21658 18.3464L-4.21609 18.303C-4.23148 21.2926 -3.65682 24.256 -2.52505 27.0232L5.28015 23.8309Z",
                  stroke: "rgba(179,179,179,1)",
                  fillRule: "nonzero",
                  strokeLinejoin: "round",
                  strokeWidth: 8,
                },
                {
                  d: "M0.000245159 18.3247C0.0777724 8.14549 8.37863 -0.0511722 18.5581 0.000240544C28.7375 0.0519253 36.9552 8.33183 36.9296 18.5113C36.904 28.6908 28.6448 36.9299 18.4653 36.9299C16.0303 36.924 13.6204 36.4377 11.3736 35.4989C9.12683 34.5601 7.08737 33.1872 5.37207 31.4589C3.65677 29.7306 2.29934 27.6808 1.37755 25.427C0.455754 23.1732 -0.0122868 20.7597 0.000245159 18.3247Z",
                  fill: "rgba(179,179,179,1)",
                  fillRule: "evenodd",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="18.27%"
              bottom="62.79%"
              left="58.02%"
              right="22.44%"
              {...getOverrideProps(overrides, "Vector753723994")}
            ></Icon>
            <Icon
              width="73.86px"
              height="27.7px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 73.85921478271484,
                height: 27.69734764099121,
              }}
              paths={[
                {
                  d: "M0 23.0811L-4.21641 23.0811L-4.21638 23.0932L0 23.0811ZM0 18.4648L-4.21639 18.4524L-4.21639 18.4648L0 18.4648ZM18.4648 0L18.4648 -4.21641L18.4524 -4.21637L18.4648 0ZM55.3944 0L55.4068 -4.21639L55.3944 -4.21639L55.3944 0ZM73.8592 18.4648L78.0756 18.4648L78.0756 18.4524L73.8592 18.4648ZM73.8592 23.0811L78.0756 23.0932L78.0756 23.0811L73.8592 23.0811ZM69.243 27.6973L69.243 31.9138L69.2556 31.9137L69.243 27.6973ZM4.61627 27.6973L4.60366 31.9137L4.61627 31.9137L4.61627 27.6973ZM4.21639 23.0811L4.21639 18.4648L-4.21639 18.4648L-4.21639 23.0811L4.21639 23.0811ZM4.21637 18.4772C4.23948 10.6107 10.6107 4.23948 18.4772 4.21637L18.4524 -4.21637C5.948 -4.17964 -4.17964 5.94801 -4.21637 18.4524L4.21637 18.4772ZM18.4648 4.21639L55.3944 4.21639L55.3944 -4.21639L18.4648 -4.21639L18.4648 4.21639ZM55.382 4.21637C63.2485 4.23948 69.6197 10.6107 69.6428 18.4772L78.0756 18.4524C78.0389 5.94801 67.9112 -4.17964 55.4068 -4.21637L55.382 4.21637ZM69.6428 18.4648L69.6428 23.0811L78.0756 23.0811L78.0756 18.4648L69.6428 18.4648ZM69.6428 23.0689C69.6422 23.2958 69.4584 23.4803 69.2303 23.481L69.2556 31.9137C74.1204 31.8992 78.0616 27.9592 78.0756 23.0932L69.6428 23.0689ZM69.243 23.481L4.61627 23.481L4.61627 31.9137L69.243 31.9137L69.243 23.481ZM4.62888 23.481C4.40083 23.4803 4.21703 23.2958 4.21638 23.0689L-4.21638 23.0932C-4.20234 27.9592 -0.261147 31.8992 4.60366 31.9137L4.62888 23.481Z",
                  stroke: "rgba(179,179,179,1)",
                  fillRule: "nonzero",
                  strokeLinejoin: "round",
                  strokeWidth: 8,
                },
                {
                  d: "M0 23.0811L0 18.4648C0.0299228 8.27936 8.27936 0.0299228 18.4648 0L55.3944 0C65.5799 0.0299228 73.8293 8.27936 73.8592 18.4648L73.8592 23.0811C73.8519 25.6275 71.7894 27.6897 69.243 27.6973L4.61627 27.6973C2.06984 27.6897 0.00734468 25.6275 0 23.0811Z",
                  fill: "rgba(179,179,179,1)",
                  fillRule: "evenodd",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="46.61%"
              bottom="39.19%"
              left="48.25%"
              right="12.67%"
              {...getOverrideProps(overrides, "Vector753723995")}
            ></Icon>
            <Icon
              width="47.27px"
              height="81.53px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 47.269832611083984,
                height: 81.53006744384766,
              }}
              paths={[
                {
                  d: "M14.7566 2.98144C16.4032 1.33484 16.4032 -1.33484 14.7566 -2.98144C13.11 -4.62804 10.4403 -4.62804 8.79372 -2.98144L14.7566 2.98144ZM3.72702 8.04814L0.745577 5.0667C-0.0451499 5.85743 -0.489376 6.92988 -0.489376 8.04814C-0.489376 9.1664 -0.0451497 10.2389 0.745578 11.0296L3.72702 8.04814ZM8.79372 19.0777C10.4403 20.7243 13.11 20.7243 14.7566 19.0777C16.4032 17.4311 16.4032 14.7614 14.7566 13.1148L8.79372 19.0777ZM38.901 -2.98144C37.2544 -4.62804 34.5847 -4.62804 32.9381 -2.98144C31.2915 -1.33484 31.2915 1.33484 32.9381 2.98144L38.901 -2.98144ZM43.9677 8.04814L46.9492 11.0296C47.7399 10.2389 48.1841 9.1664 48.1841 8.04814C48.1841 6.92988 47.7399 5.85743 46.9492 5.0667L43.9677 8.04814ZM32.9381 13.1148C31.2915 14.7614 31.2915 17.4311 32.9381 19.0777C34.5847 20.7243 37.2544 20.7243 38.901 19.0777L32.9381 13.1148ZM0 34.7042C-2.32865 34.7042 -4.21639 36.5919 -4.21639 38.9206C-4.21639 41.2492 -2.32865 43.137 0 43.137L0 34.7042ZM47.2698 43.137C49.5985 43.137 51.4862 41.2492 51.4862 38.9206C51.4862 36.5919 49.5985 34.7042 47.2698 34.7042L47.2698 43.137ZM0 56.0089C-2.32865 56.0089 -4.21639 57.8967 -4.21639 60.2253C-4.21639 62.554 -2.32865 64.4417 0 64.4417L0 56.0089ZM47.2698 64.4417C49.5985 64.4417 51.4862 62.554 51.4862 60.2253C51.4862 57.8967 49.5985 56.0089 47.2698 56.0089L47.2698 64.4417ZM0 77.3137C-2.32865 77.3137 -4.21639 79.2014 -4.21639 81.5301C-4.21639 83.8587 -2.32865 85.7465 0 85.7465L0 77.3137ZM47.2698 85.7465C49.5985 85.7465 51.4862 83.8587 51.4862 81.5301C51.4862 79.2014 49.5985 77.3137 47.2698 77.3137L47.2698 85.7465ZM8.79372 -2.98144L0.745577 5.0667L6.70846 11.0296L14.7566 2.98144L8.79372 -2.98144ZM0.745578 11.0296L8.79372 19.0777L14.7566 13.1148L6.70846 5.0667L0.745578 11.0296ZM32.9381 2.98144L40.9863 11.0296L46.9492 5.0667L38.901 -2.98144L32.9381 2.98144ZM40.9863 5.0667L32.9381 13.1148L38.901 19.0777L46.9492 11.0296L40.9863 5.0667ZM0 43.137L47.2698 43.137L47.2698 34.7042L0 34.7042L0 43.137ZM0 64.4417L47.2698 64.4417L47.2698 56.0089L0 56.0089L0 64.4417ZM0 85.7465L47.2698 85.7465L47.2698 77.3137L0 77.3137L0 85.7465Z",
                  stroke: "rgba(179,179,179,1)",
                  fillRule: "nonzero",
                  strokeLinejoin: "round",
                  strokeWidth: 8,
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="18.32%"
              bottom="39.87%"
              left="12.85%"
              right="62.14%"
              {...getOverrideProps(overrides, "Vector753723996")}
            ></Icon>
            <Flex
              gap="5.044227600097656px"
              direction="column"
              width="154.61px"
              height="39.85px"
              justifyContent="space-between"
              alignItems="center"
              overflow="hidden"
              position="absolute"
              top="71.16%"
              bottom="8.4%"
              left="9.7%"
              right="8.49%"
              border="0.5px SOLID rgba(203,163,58,1)"
              borderRadius="2.017690896987915px"
              padding="7.061918675899506px 12.255072057247162px 7.061918675899506px 12.255072057247162px"
              backgroundColor="rgba(255,255,255,1)"
              {...getOverrideProps(overrides, "Frame 427318909753723997")}
            >
              <Flex
                gap="3.530959129333496px"
                direction="row"
                width="unset"
                height="unset"
                justifyContent="center"
                alignItems="center"
                shrink="0"
                position="relative"
                padding="0px 0px 0px 0px"
                {...getOverrideProps(overrides, "Frame 427318911753723998")}
              >
                <Text
                  fontFamily="Inter"
                  fontSize="16.645952224731445px"
                  fontWeight="700"
                  color="rgba(0,0,0,1)"
                  lineHeight="24.968929290771484px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="77%"
                  {...getOverrideProps(overrides, "77%")}
                ></Text>
                <Flex
                  gap="5.044227600097656px"
                  direction="row"
                  width="unset"
                  height="unset"
                  justifyContent="center"
                  alignItems="center"
                  shrink="0"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  {...getOverrideProps(overrides, "Frame 427318934753724000")}
                >
                  <Text
                    fontFamily="Inter"
                    fontSize="10.088455200195312px"
                    fontWeight="600"
                    color="rgba(0,0,0,1)"
                    lineHeight="10.945974349975586px"
                    textAlign="left"
                    display="block"
                    direction="column"
                    justifyContent="unset"
                    width="unset"
                    height="unset"
                    gap="unset"
                    alignItems="unset"
                    shrink="0"
                    position="relative"
                    padding="0px 0px 0px 0px"
                    whiteSpace="pre-wrap"
                    children="Match"
                    {...getOverrideProps(overrides, "Match753724001")}
                  ></Text>
                  <Flex
                    gap="5.044227600097656px"
                    direction="row"
                    width="unset"
                    height="unset"
                    justifyContent="center"
                    alignItems="center"
                    overflow="hidden"
                    shrink="0"
                    position="relative"
                    borderRadius="3.530959129333496px"
                    padding="1.0088454484939575px 4.03538179397583px 1.0088454484939575px 4.03538179397583px"
                    backgroundColor="rgba(203,163,58,1)"
                    {...getOverrideProps(overrides, "Frame 427318910753724002")}
                  >
                    <Text
                      fontFamily="Inter"
                      fontSize="10.088455200195312px"
                      fontWeight="600"
                      color="rgba(255,255,255,1)"
                      lineHeight="10.945974349975586px"
                      textAlign="left"
                      display="block"
                      direction="column"
                      justifyContent="unset"
                      width="unset"
                      height="unset"
                      gap="unset"
                      alignItems="unset"
                      shrink="0"
                      position="relative"
                      padding="0px 0px 0px 0px"
                      whiteSpace="pre-wrap"
                      children="Good"
                      {...getOverrideProps(overrides, "Good")}
                    ></Text>
                  </Flex>
                </Flex>
              </Flex>
            </Flex>
          </View>
          <View
            width="189px"
            height="195px"
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            overflow="hidden"
            position="absolute"
            top="327px"
            left="212px"
            border="1px SOLID rgba(225,225,225,1)"
            borderRadius="8px"
            padding="0px 0px 0px 0px"
            backgroundColor="rgba(255,255,255,1)"
            {...getOverrideProps(overrides, "389 4")}
          >
            <Icon
              width="244.82px"
              height="163.22px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 244.82278442382812,
                height: 163.21519470214844,
              }}
              paths={[]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="0%"
              bottom="16.3%"
              left="0%"
              right="-29.54%"
              {...getOverrideProps(overrides, "Vector753724005")}
            ></Icon>
            <Icon
              width="30.35px"
              height="22.09px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 30.35285758972168,
                height: 22.09178924560547,
              }}
              paths={[
                {
                  d: "M9.9515 19.7567C18.331 24.7791 30.3529 20.1365 30.3529 20.1365C30.3529 20.1365 28.7808 7.35291 20.3965 2.33649C12.0167 -2.68564 0 1.9513 0 1.9513C0 1.9513 1.57176 14.7346 9.9515 19.7567Z",
                  fillRule: "nonzero",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="58.04%"
              bottom="30.63%"
              left="13.52%"
              right="70.42%"
              {...getOverrideProps(overrides, "Vector753724006")}
            ></Icon>
            <Icon
              width="7px"
              height="7px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 7.003564834594727,
                height: 7.0035600662231445,
              }}
              paths={[
                {
                  d: "M3.50178 7.00356C5.43576 7.00356 7.00357 5.43576 7.00357 3.50178C7.00357 1.5678 5.43576 0 3.50178 0C1.5678 0 0 1.5678 0 3.50178C0 5.43576 1.5678 7.00356 3.50178 7.00356Z",
                  fill: "rgba(179,179,179,1)",
                  fillRule: "nonzero",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="28.33%"
              bottom="68.08%"
              left="50.91%"
              right="45.38%"
              transformOrigin="top left"
              transform="rotate(180deg)"
              {...getOverrideProps(overrides, "Vector753724007")}
            ></Icon>
            <Icon
              width="7.88px"
              height="7.88px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 7.878946781158447,
                height: 7.878946781158447,
              }}
              paths={[
                {
                  d: "M3.93947 7.87895C6.11518 7.87895 7.87895 6.11519 7.87895 3.93948C7.87895 1.76377 6.11518 0 3.93947 0C1.76376 0 0 1.76377 0 3.93948C0 6.11519 1.76376 7.87895 3.93947 7.87895Z",
                  fill: "rgba(179,179,179,1)",
                  fillRule: "nonzero",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="40.26%"
              bottom="55.7%"
              left="40.35%"
              right="55.48%"
              transformOrigin="top left"
              transform="rotate(180deg)"
              {...getOverrideProps(overrides, "Vector753724008")}
            ></Icon>
            <Icon
              width="3.94px"
              height="3.94px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 3.9394707679748535,
                height: 3.9394707679748535,
              }}
              paths={[
                {
                  d: "M1.96974 3.93947C3.05759 3.93947 3.93947 3.05759 3.93947 1.96974C3.93947 0.881881 3.05759 0 1.96974 0C0.881881 0 0 0.881881 0 1.96974C0 3.05759 0.881881 3.93947 1.96974 3.93947Z",
                  fill: "rgba(225,228,229,1)",
                  fillRule: "nonzero",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="69.17%"
              bottom="28.81%"
              left="97.88%"
              right="0.04%"
              transformOrigin="top left"
              transform="rotate(180deg)"
              {...getOverrideProps(overrides, "Vector753724009")}
            ></Icon>
            <Icon
              width="5.69px"
              height="5.69px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 5.690225601196289,
                height: 5.690225601196289,
              }}
              paths={[
                {
                  d: "M2.84511 5.69023C4.41643 5.69023 5.69023 4.41643 5.69023 2.84511C5.69023 1.2738 4.41643 0 2.84511 0C1.2738 0 0 1.2738 0 2.84511C0 4.41643 1.2738 5.69023 2.84511 5.69023Z",
                  fill: "rgba(225,228,229,1)",
                  fillRule: "nonzero",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="58.23%"
              bottom="38.85%"
              left="25.49%"
              right="71.5%"
              transformOrigin="top left"
              transform="rotate(180deg)"
              {...getOverrideProps(overrides, "Vector753724010")}
            ></Icon>
            <Icon
              width="4.33px"
              height="4.33px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 4.330643177032471,
                height: 4.330643177032471,
              }}
              paths={[
                {
                  d: "M2.16532 4.33064C3.3612 4.33064 4.33064 3.3612 4.33064 2.16532C4.33064 0.969447 3.3612 0 2.16532 0C0.969447 0 0 0.969447 0 2.16532C0 3.3612 0.969447 4.33064 2.16532 4.33064Z",
                  fill: "rgba(225,228,229,1)",
                  fillRule: "nonzero",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="44.21%"
              bottom="53.57%"
              left="49.47%"
              right="48.24%"
              transformOrigin="top left"
              transform="rotate(180deg)"
              {...getOverrideProps(overrides, "Vector753724011")}
            ></Icon>
            <Icon
              width="4.81px"
              height="4.81px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 4.814847946166992,
                height: 4.814847946166992,
              }}
              paths={[
                {
                  d: "M2.40742 4.81485C3.73701 4.81485 4.81485 3.73701 4.81485 2.40742C4.81485 1.07784 3.73701 0 2.40742 0C1.07784 0 0 1.07784 0 2.40742C0 3.73701 1.07784 4.81485 2.40742 4.81485Z",
                  fill: "rgba(225,228,229,1)",
                  fillRule: "nonzero",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="16.91%"
              bottom="80.62%"
              left="93.92%"
              right="3.54%"
              transformOrigin="top left"
              transform="rotate(180deg)"
              {...getOverrideProps(overrides, "Vector753724012")}
            ></Icon>
            <Icon
              width="4.32px"
              height="4.32px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 5.295270426580828,
                height: 5.295270426584466,
              }}
              paths={[
                {
                  d: "M2.16179 4.32357C3.35571 4.32357 4.32357 3.35571 4.32357 2.16179C4.32357 0.967864 3.35571 0 2.16179 0C0.967864 0 0 0.967864 0 2.16179C0 3.35571 0.967864 4.32357 2.16179 4.32357Z",
                  fill: "rgba(225,228,229,1)",
                  fillRule: "nonzero",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="30.19%"
              bottom="67.59%"
              left="36.85%"
              right="60.87%"
              transformOrigin="top left"
              transform="rotate(75deg)"
              {...getOverrideProps(overrides, "Vector753724013")}
            ></Icon>
            <Icon
              width="5.75px"
              height="5.75px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 5.751703262329102,
                height: 5.751703262329102,
              }}
              paths={[
                {
                  d: "M2.87585 5.7517C4.46414 5.7517 5.7517 4.46414 5.7517 2.87585C5.7517 1.28756 4.46414 0 2.87585 0C1.28756 0 0 1.28756 0 2.87585C0 4.46414 1.28756 5.7517 2.87585 5.7517Z",
                  fill: "rgba(225,228,229,1)",
                  fillRule: "nonzero",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="12.39%"
              bottom="84.66%"
              left="61.12%"
              right="35.84%"
              transformOrigin="top left"
              transform="rotate(180deg)"
              {...getOverrideProps(overrides, "Vector753724014")}
            ></Icon>
            <Icon
              width="4.42px"
              height="3.54px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 4.4247636795043945,
                height: 3.53959321975708,
              }}
              paths={[
                {
                  d: "M2.21238 3.53959C3.43425 3.53959 4.42476 2.74723 4.42476 1.7698C4.42476 0.792365 3.43425 0 2.21238 0C0.990517 0 0 0.792365 0 1.7698C0 2.74723 0.990517 3.53959 2.21238 3.53959Z",
                  fill: "rgba(225,228,229,1)",
                  fillRule: "nonzero",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="49.89%"
              bottom="48.3%"
              left="106.18%"
              right="-8.52%"
              transformOrigin="top left"
              transform="rotate(180deg)"
              {...getOverrideProps(overrides, "Vector753724015")}
            ></Icon>
            <Icon
              width="9px"
              height="9px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 11.020986735878978,
                height: 11.020986735878978,
              }}
              paths={[
                {
                  d: "M4.4993 8.9986C6.98419 8.9986 8.9986 6.98419 8.9986 4.4993C8.9986 2.01441 6.98419 0 4.4993 0C2.01441 0 0 2.01441 0 4.4993C0 6.98419 2.01441 8.9986 4.4993 8.9986Z",
                  fill: "rgba(225,228,229,1)",
                  fillRule: "nonzero",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="22.03%"
              bottom="73.36%"
              left="77.52%"
              right="17.72%"
              transformOrigin="top left"
              transform="rotate(75deg)"
              {...getOverrideProps(overrides, "Vector753724016")}
            ></Icon>
            <Icon
              width="152.98px"
              height="56.82px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 152.975341796875,
                height: 56.817386627197266,
              }}
              paths={[
                {
                  d: "M148.964 0L149.021 0C149.364 4.85592 152.975 4.93046 152.975 4.93046C152.975 4.93046 148.993 5.00826 148.993 10.619C148.993 5.00826 145.011 4.93046 145.011 4.93046C145.011 4.93046 148.621 4.85592 148.964 0ZM3.50695 47.2065L3.55837 47.2065C3.86249 51.6013 7.06667 51.669 7.06667 51.669C7.06667 51.669 3.53334 51.7392 3.53334 56.8174C3.53334 51.7392 0 51.669 0 51.669C0 51.669 3.20282 51.6013 3.50695 47.2065Z",
                  fill: "rgba(225,228,229,1)",
                  fillRule: "nonzero",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="44.53%"
              bottom="26.34%"
              left="35.07%"
              right="-16.01%"
              {...getOverrideProps(overrides, "Vector753724017")}
            ></Icon>
            <Icon
              width="36.93px"
              height="36.93px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 36.92964172363281,
                height: 36.92985534667969,
              }}
              paths={[
                {
                  d: "M0.000245159 18.3247L-4.21604 18.2926L-4.21609 18.303L0.000245159 18.3247ZM18.5581 0.000240544L18.5795 -4.2161L18.5794 -4.2161L18.5581 0.000240544ZM18.4653 36.9299L18.4552 41.1462L18.4653 41.1462L18.4653 36.9299ZM4.21652 18.3568C4.27634 10.5019 10.6818 4.17691 18.5368 4.21658L18.5794 -4.2161C6.07545 -4.27925 -4.1208 5.78909 -4.21603 18.2926L4.21652 18.3568ZM18.5367 4.21658C26.3918 4.25646 32.7329 10.6458 32.7132 18.5007L41.146 18.5219C41.1774 6.0179 31.0832 -4.15261 18.5795 -4.2161L18.5367 4.21658ZM32.7132 18.5007C32.6935 26.3558 26.3201 32.7135 18.4653 32.7135L18.4653 41.1462C30.9695 41.1462 41.1146 31.0257 41.146 18.5219L32.7132 18.5007ZM18.4755 32.7135C16.5952 32.7089 14.7342 32.3334 12.9992 31.6085L9.74801 39.3893C12.5066 40.542 15.4655 41.139 18.4552 41.1462L18.4755 32.7135ZM12.9992 31.6085C11.2642 30.8835 9.68933 29.8234 8.36476 28.4888L2.37939 34.4291C4.48542 36.5511 6.98945 38.2367 9.74801 39.3893L12.9992 31.6085ZM8.36476 28.4888C7.04019 27.1541 5.99197 25.5713 5.28015 23.8309L-2.52505 27.0232C-1.39328 29.7904 0.273355 32.307 2.37939 34.4291L8.36476 28.4888ZM5.28015 23.8309C4.56833 22.0905 4.2069 20.2267 4.21658 18.3464L-4.21609 18.303C-4.23148 21.2926 -3.65682 24.256 -2.52505 27.0232L5.28015 23.8309Z",
                  stroke: "rgba(179,179,179,1)",
                  fillRule: "nonzero",
                  strokeLinejoin: "round",
                  strokeWidth: 8,
                },
                {
                  d: "M0.000245159 18.3247C0.0777724 8.14549 8.37863 -0.0511722 18.5581 0.000240544C28.7375 0.0519253 36.9552 8.33183 36.9296 18.5113C36.904 28.6908 28.6448 36.9299 18.4653 36.9299C16.0303 36.924 13.6204 36.4377 11.3736 35.4989C9.12683 34.5601 7.08737 33.1872 5.37207 31.4589C3.65677 29.7306 2.29934 27.6808 1.37755 25.427C0.455754 23.1732 -0.0122868 20.7597 0.000245159 18.3247Z",
                  fill: "rgba(179,179,179,1)",
                  fillRule: "evenodd",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="18.27%"
              bottom="62.79%"
              left="58.02%"
              right="22.44%"
              {...getOverrideProps(overrides, "Vector753724018")}
            ></Icon>
            <Icon
              width="73.86px"
              height="27.7px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 73.85921478271484,
                height: 27.69734764099121,
              }}
              paths={[
                {
                  d: "M0 23.0811L-4.21641 23.0811L-4.21638 23.0932L0 23.0811ZM0 18.4648L-4.21639 18.4524L-4.21639 18.4648L0 18.4648ZM18.4648 0L18.4648 -4.21641L18.4524 -4.21637L18.4648 0ZM55.3944 0L55.4068 -4.21639L55.3944 -4.21639L55.3944 0ZM73.8592 18.4648L78.0756 18.4648L78.0756 18.4524L73.8592 18.4648ZM73.8592 23.0811L78.0756 23.0932L78.0756 23.0811L73.8592 23.0811ZM69.243 27.6973L69.243 31.9138L69.2556 31.9137L69.243 27.6973ZM4.61627 27.6973L4.60366 31.9137L4.61627 31.9137L4.61627 27.6973ZM4.21639 23.0811L4.21639 18.4648L-4.21639 18.4648L-4.21639 23.0811L4.21639 23.0811ZM4.21637 18.4772C4.23948 10.6107 10.6107 4.23948 18.4772 4.21637L18.4524 -4.21637C5.948 -4.17964 -4.17964 5.94801 -4.21637 18.4524L4.21637 18.4772ZM18.4648 4.21639L55.3944 4.21639L55.3944 -4.21639L18.4648 -4.21639L18.4648 4.21639ZM55.382 4.21637C63.2485 4.23948 69.6197 10.6107 69.6428 18.4772L78.0756 18.4524C78.0389 5.94801 67.9112 -4.17964 55.4068 -4.21637L55.382 4.21637ZM69.6428 18.4648L69.6428 23.0811L78.0756 23.0811L78.0756 18.4648L69.6428 18.4648ZM69.6428 23.0689C69.6422 23.2958 69.4584 23.4803 69.2303 23.481L69.2556 31.9137C74.1204 31.8992 78.0616 27.9592 78.0756 23.0932L69.6428 23.0689ZM69.243 23.481L4.61627 23.481L4.61627 31.9137L69.243 31.9137L69.243 23.481ZM4.62888 23.481C4.40083 23.4803 4.21703 23.2958 4.21638 23.0689L-4.21638 23.0932C-4.20234 27.9592 -0.261147 31.8992 4.60366 31.9137L4.62888 23.481Z",
                  stroke: "rgba(179,179,179,1)",
                  fillRule: "nonzero",
                  strokeLinejoin: "round",
                  strokeWidth: 8,
                },
                {
                  d: "M0 23.0811L0 18.4648C0.0299228 8.27936 8.27936 0.0299228 18.4648 0L55.3944 0C65.5799 0.0299228 73.8293 8.27936 73.8592 18.4648L73.8592 23.0811C73.8519 25.6275 71.7894 27.6897 69.243 27.6973L4.61627 27.6973C2.06984 27.6897 0.00734468 25.6275 0 23.0811Z",
                  fill: "rgba(179,179,179,1)",
                  fillRule: "evenodd",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="46.61%"
              bottom="39.19%"
              left="48.25%"
              right="12.67%"
              {...getOverrideProps(overrides, "Vector753724019")}
            ></Icon>
            <Icon
              width="47.27px"
              height="81.53px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 47.269832611083984,
                height: 81.53006744384766,
              }}
              paths={[
                {
                  d: "M14.7566 2.98144C16.4032 1.33484 16.4032 -1.33484 14.7566 -2.98144C13.11 -4.62804 10.4403 -4.62804 8.79372 -2.98144L14.7566 2.98144ZM3.72702 8.04814L0.745577 5.0667C-0.0451499 5.85743 -0.489376 6.92988 -0.489376 8.04814C-0.489376 9.1664 -0.0451497 10.2389 0.745578 11.0296L3.72702 8.04814ZM8.79372 19.0777C10.4403 20.7243 13.11 20.7243 14.7566 19.0777C16.4032 17.4311 16.4032 14.7614 14.7566 13.1148L8.79372 19.0777ZM38.901 -2.98144C37.2544 -4.62804 34.5847 -4.62804 32.9381 -2.98144C31.2915 -1.33484 31.2915 1.33484 32.9381 2.98144L38.901 -2.98144ZM43.9677 8.04814L46.9492 11.0296C47.7399 10.2389 48.1841 9.1664 48.1841 8.04814C48.1841 6.92988 47.7399 5.85743 46.9492 5.0667L43.9677 8.04814ZM32.9381 13.1148C31.2915 14.7614 31.2915 17.4311 32.9381 19.0777C34.5847 20.7243 37.2544 20.7243 38.901 19.0777L32.9381 13.1148ZM0 34.7042C-2.32865 34.7042 -4.21639 36.5919 -4.21639 38.9206C-4.21639 41.2492 -2.32865 43.137 0 43.137L0 34.7042ZM47.2698 43.137C49.5985 43.137 51.4862 41.2492 51.4862 38.9206C51.4862 36.5919 49.5985 34.7042 47.2698 34.7042L47.2698 43.137ZM0 56.0089C-2.32865 56.0089 -4.21639 57.8967 -4.21639 60.2253C-4.21639 62.554 -2.32865 64.4417 0 64.4417L0 56.0089ZM47.2698 64.4417C49.5985 64.4417 51.4862 62.554 51.4862 60.2253C51.4862 57.8967 49.5985 56.0089 47.2698 56.0089L47.2698 64.4417ZM0 77.3137C-2.32865 77.3137 -4.21639 79.2014 -4.21639 81.5301C-4.21639 83.8587 -2.32865 85.7465 0 85.7465L0 77.3137ZM47.2698 85.7465C49.5985 85.7465 51.4862 83.8587 51.4862 81.5301C51.4862 79.2014 49.5985 77.3137 47.2698 77.3137L47.2698 85.7465ZM8.79372 -2.98144L0.745577 5.0667L6.70846 11.0296L14.7566 2.98144L8.79372 -2.98144ZM0.745578 11.0296L8.79372 19.0777L14.7566 13.1148L6.70846 5.0667L0.745578 11.0296ZM32.9381 2.98144L40.9863 11.0296L46.9492 5.0667L38.901 -2.98144L32.9381 2.98144ZM40.9863 5.0667L32.9381 13.1148L38.901 19.0777L46.9492 11.0296L40.9863 5.0667ZM0 43.137L47.2698 43.137L47.2698 34.7042L0 34.7042L0 43.137ZM0 64.4417L47.2698 64.4417L47.2698 56.0089L0 56.0089L0 64.4417ZM0 85.7465L47.2698 85.7465L47.2698 77.3137L0 77.3137L0 85.7465Z",
                  stroke: "rgba(179,179,179,1)",
                  fillRule: "nonzero",
                  strokeLinejoin: "round",
                  strokeWidth: 8,
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="18.32%"
              bottom="39.87%"
              left="12.85%"
              right="62.14%"
              {...getOverrideProps(overrides, "Vector753724020")}
            ></Icon>
            <Flex
              gap="5.044227600097656px"
              direction="column"
              width="154.61px"
              height="39.85px"
              justifyContent="space-between"
              alignItems="center"
              overflow="hidden"
              position="absolute"
              top="71.16%"
              bottom="8.4%"
              left="9.7%"
              right="8.49%"
              border="0.5px SOLID rgba(71,160,80,1)"
              borderRadius="2.017690896987915px"
              padding="7.061918675899506px 12.255072057247162px 7.061918675899506px 12.255072057247162px"
              backgroundColor="rgba(255,255,255,1)"
              {...getOverrideProps(overrides, "Frame 427318909753724021")}
            >
              <Flex
                gap="3.530959129333496px"
                direction="row"
                width="unset"
                height="unset"
                justifyContent="center"
                alignItems="center"
                shrink="0"
                position="relative"
                padding="0px 0px 0px 0px"
                {...getOverrideProps(overrides, "Frame 427318911753724022")}
              >
                <Text
                  fontFamily="Inter"
                  fontSize="16.645952224731445px"
                  fontWeight="700"
                  color="rgba(0,0,0,1)"
                  lineHeight="24.968929290771484px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="80%"
                  {...getOverrideProps(overrides, "80%")}
                ></Text>
                <Flex
                  gap="5.044227600097656px"
                  direction="row"
                  width="unset"
                  height="unset"
                  justifyContent="center"
                  alignItems="center"
                  shrink="0"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  {...getOverrideProps(overrides, "Frame 427318934753724024")}
                >
                  <Text
                    fontFamily="Inter"
                    fontSize="10.088455200195312px"
                    fontWeight="600"
                    color="rgba(0,0,0,1)"
                    lineHeight="10.945974349975586px"
                    textAlign="left"
                    display="block"
                    direction="column"
                    justifyContent="unset"
                    width="unset"
                    height="unset"
                    gap="unset"
                    alignItems="unset"
                    shrink="0"
                    position="relative"
                    padding="0px 0px 0px 0px"
                    whiteSpace="pre-wrap"
                    children="Match"
                    {...getOverrideProps(overrides, "Match753724025")}
                  ></Text>
                  <Flex
                    gap="5.044227600097656px"
                    direction="row"
                    width="unset"
                    height="unset"
                    justifyContent="center"
                    alignItems="center"
                    overflow="hidden"
                    shrink="0"
                    position="relative"
                    borderRadius="3.530959129333496px"
                    padding="1.0088454484939575px 4.03538179397583px 1.0088454484939575px 4.03538179397583px"
                    backgroundColor="rgba(71,160,80,1)"
                    {...getOverrideProps(overrides, "Frame 427318910753724026")}
                  >
                    <Text
                      fontFamily="Inter"
                      fontSize="10.088455200195312px"
                      fontWeight="600"
                      color="rgba(255,255,255,1)"
                      lineHeight="10.945974349975586px"
                      textAlign="left"
                      display="block"
                      direction="column"
                      justifyContent="unset"
                      width="unset"
                      height="unset"
                      gap="unset"
                      alignItems="unset"
                      shrink="0"
                      position="relative"
                      padding="0px 0px 0px 0px"
                      whiteSpace="pre-wrap"
                      children="Great"
                      {...getOverrideProps(overrides, "Great753724027")}
                    ></Text>
                  </Flex>
                </Flex>
              </Flex>
            </Flex>
          </View>
          <View
            width="257px"
            height="255.92px"
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            overflow="hidden"
            position="absolute"
            top="43px"
            left="211px"
            border="1.36px SOLID rgba(71,160,80,1)"
            boxShadow="0px 0px 206.22999572753906px rgba(0, 0, 0, 0.10000000149011612)"
            borderRadius="10.878307342529297px"
            padding="0px 0px 0px 0px"
            backgroundColor="rgba(255,255,255,1)"
            {...getOverrideProps(overrides, "389 2")}
          >
            <Icon
              width="332.91px"
              height="221.94px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 332.9071960449219,
                height: 221.93812561035156,
              }}
              paths={[]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="0%"
              bottom="13.28%"
              left="0%"
              right="-29.54%"
              {...getOverrideProps(overrides, "Vector753724029")}
            ></Icon>
            <Icon
              width="41.27px"
              height="30.04px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 41.27346420288086,
                height: 30.040159225463867,
              }}
              paths={[
                {
                  d: "M13.5319 26.865C24.9262 33.6944 41.2735 27.3813 41.2735 27.3813C41.2735 27.3813 39.1358 9.99841 27.7349 3.17714C16.3402 -3.6519 0 2.65336 0 2.65336C0 2.65336 2.13726 20.0359 13.5319 26.865Z",
                  fillRule: "nonzero",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="60.14%"
              bottom="28.12%"
              left="13.52%"
              right="70.42%"
              {...getOverrideProps(overrides, "Vector753724030")}
            ></Icon>
            <Icon
              width="9.52px"
              height="9.52px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 9.52336597442627,
                height: 9.523359298706055,
              }}
              paths={[
                {
                  d: "M4.76168 9.52336C7.39148 9.52336 9.52337 7.39148 9.52337 4.76168C9.52337 2.13187 7.39148 0 4.76168 0C2.13187 0 0 2.13187 0 4.76168C0 7.39148 2.13187 9.52336 4.76168 9.52336Z",
                  fill: "rgba(179,179,179,1)",
                  fillRule: "nonzero",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="29.35%"
              bottom="66.93%"
              left="50.91%"
              right="45.38%"
              transformOrigin="top left"
              transform="rotate(180deg)"
              {...getOverrideProps(overrides, "Vector753724031")}
            ></Icon>
            <Icon
              width="10.71px"
              height="10.71px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 10.713700294494629,
                height: 10.713700294494629,
              }}
              paths={[
                {
                  d: "M5.35684 10.7137C8.31535 10.7137 10.7137 8.31536 10.7137 5.35686C10.7137 2.39835 8.31535 0 5.35684 0C2.39834 0 0 2.39835 0 5.35686C0 8.31536 2.39834 10.7137 5.35684 10.7137Z",
                  fill: "rgba(179,179,179,1)",
                  fillRule: "nonzero",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="41.72%"
              bottom="54.1%"
              left="40.35%"
              right="55.48%"
              transformOrigin="top left"
              transform="rotate(180deg)"
              {...getOverrideProps(overrides, "Vector753724032")}
            ></Icon>
            <Icon
              width="5.36px"
              height="5.36px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 5.356846809387207,
                height: 5.356846809387207,
              }}
              paths={[
                {
                  d: "M2.67842 5.35685C4.15768 5.35685 5.35685 4.15768 5.35685 2.67842C5.35685 1.19917 4.15768 0 2.67842 0C1.19917 0 0 1.19917 0 2.67842C0 4.15768 1.19917 5.35685 2.67842 5.35685Z",
                  fill: "rgba(225,228,229,1)",
                  fillRule: "nonzero",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="71.67%"
              bottom="26.24%"
              left="97.88%"
              right="0.04%"
              transformOrigin="top left"
              transform="rotate(180deg)"
              {...getOverrideProps(overrides, "Vector753724033")}
            ></Icon>
            <Icon
              width="7.74px"
              height="7.74px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 7.737502574920654,
                height: 7.737502574920654,
              }}
              paths={[
                {
                  d: "M3.86875 7.7375C6.0054 7.7375 7.7375 6.0054 7.7375 3.86875C7.7375 1.7321 6.0054 0 3.86875 0C1.7321 0 0 1.7321 0 3.86875C0 6.0054 1.7321 7.7375 3.86875 7.7375Z",
                  fill: "rgba(225,228,229,1)",
                  fillRule: "nonzero",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="60.33%"
              bottom="36.64%"
              left="25.49%"
              right="71.5%"
              transformOrigin="top left"
              transform="rotate(180deg)"
              {...getOverrideProps(overrides, "Vector753724034")}
            ></Icon>
            <Icon
              width="5.89px"
              height="5.89px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 5.888758182525635,
                height: 5.888758182525635,
              }}
              paths={[
                {
                  d: "M2.94438 5.88876C4.57051 5.88876 5.88876 4.57051 5.88876 2.94438C5.88876 1.31824 4.57051 0 2.94438 0C1.31824 0 0 1.31824 0 2.94438C0 4.57051 1.31824 5.88876 2.94438 5.88876Z",
                  fill: "rgba(225,228,229,1)",
                  fillRule: "nonzero",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="45.8%"
              bottom="51.9%"
              left="49.47%"
              right="48.24%"
              transformOrigin="top left"
              transform="rotate(180deg)"
              {...getOverrideProps(overrides, "Vector753724035")}
            ></Icon>
            <Icon
              width="6.55px"
              height="6.55px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 6.547173976898193,
                height: 6.547173976898193,
              }}
              paths={[
                {
                  d: "M3.27359 6.54717C5.08154 6.54717 6.54717 5.08154 6.54717 3.27359C6.54717 1.46563 5.08154 0 3.27359 0C1.46563 0 0 1.46563 0 3.27359C0 5.08154 1.46563 6.54717 3.27359 6.54717Z",
                  fill: "rgba(225,228,229,1)",
                  fillRule: "nonzero",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="17.52%"
              bottom="79.92%"
              left="93.92%"
              right="3.54%"
              transformOrigin="top left"
              transform="rotate(180deg)"
              {...getOverrideProps(overrides, "Vector753724036")}
            ></Icon>
            <Icon
              width="5.88px"
              height="5.88px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 7.200446936589287,
                height: 7.200446936589287,
              }}
              paths={[
                {
                  d: "M2.93957 5.87914C4.56305 5.87914 5.87914 4.56305 5.87914 2.93957C5.87914 1.31609 4.56305 0 2.93957 0C1.31609 0 0 1.31609 0 2.93957C0 4.56305 1.31609 5.87914 2.93957 5.87914Z",
                  fill: "rgba(225,228,229,1)",
                  fillRule: "nonzero",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="31.28%"
              bottom="66.42%"
              left="36.85%"
              right="60.87%"
              transformOrigin="top left"
              transform="rotate(75deg)"
              {...getOverrideProps(overrides, "Vector753724037")}
            ></Icon>
            <Icon
              width="7.82px"
              height="7.82px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 7.821099281311035,
                height: 7.821099281311035,
              }}
              paths={[
                {
                  d: "M3.91055 7.8211C6.07029 7.8211 7.8211 6.07029 7.8211 3.91055C7.8211 1.75081 6.07029 0 3.91055 0C1.75081 0 0 1.75081 0 3.91055C0 6.07029 1.75081 7.8211 3.91055 7.8211Z",
                  fill: "rgba(225,228,229,1)",
                  fillRule: "nonzero",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="12.84%"
              bottom="84.11%"
              left="61.12%"
              right="35.84%"
              transformOrigin="top left"
              transform="rotate(180deg)"
              {...getOverrideProps(overrides, "Vector753724038")}
            ></Icon>
            <Icon
              width="6.02px"
              height="4.81px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 6.01674222946167,
                height: 4.8130974769592285,
              }}
              paths={[
                {
                  d: "M3.00837 4.8131C4.66985 4.8131 6.01674 3.73565 6.01674 2.40655C6.01674 1.07745 4.66985 0 3.00837 0C1.34689 0 0 1.07745 0 2.40655C0 3.73565 1.34689 4.8131 3.00837 4.8131Z",
                  fill: "rgba(225,228,229,1)",
                  fillRule: "nonzero",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="51.69%"
              bottom="46.43%"
              left="106.18%"
              right="-8.52%"
              transformOrigin="top left"
              transform="rotate(180deg)"
              {...getOverrideProps(overrides, "Vector753724039")}
            ></Icon>
            <Icon
              width="12.24px"
              height="12.24px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 14.986209402672102,
                height: 14.986209402672102,
              }}
              paths={[
                {
                  d: "M6.11809 12.2362C9.49702 12.2362 12.2362 9.49702 12.2362 6.11809C12.2362 2.73916 9.49702 0 6.11809 0C2.73916 0 0 2.73916 0 6.11809C0 9.49702 2.73916 12.2362 6.11809 12.2362Z",
                  fill: "rgba(225,228,229,1)",
                  fillRule: "nonzero",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="22.82%"
              bottom="72.4%"
              left="77.52%"
              right="17.72%"
              transformOrigin="top left"
              transform="rotate(75deg)"
              {...getOverrideProps(overrides, "Vector753724040")}
            ></Icon>
            <Icon
              width="208.01px"
              height="77.26px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 208.01409912109375,
                height: 77.2596206665039,
              }}
              paths={[
                {
                  d: "M202.559 0L202.638 0C203.104 6.60303 208.014 6.70438 208.014 6.70438C208.014 6.70438 202.599 6.81017 202.599 14.4397C202.599 6.81017 197.184 6.70438 197.184 6.70438C197.184 6.70438 202.093 6.60303 202.559 0ZM4.7687 64.1908L4.83862 64.1908C5.25217 70.1668 9.60917 70.2589 9.60917 70.2589C9.60917 70.2589 4.80459 70.3544 4.80459 77.2596C4.80459 70.3544 0 70.2589 0 70.2589C0 70.2589 4.35516 70.1668 4.7687 64.1908Z",
                  fill: "rgba(225,228,229,1)",
                  fillRule: "nonzero",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="46.13%"
              bottom="23.68%"
              left="35.07%"
              right="-16.01%"
              {...getOverrideProps(overrides, "Vector753724041")}
            ></Icon>
            <Icon
              width="50.22px"
              height="50.22px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 50.216495513916016,
                height: 50.21678924560547,
              }}
              paths={[
                {
                  d: "M0.000333364 24.9177L-5.7329 24.874C-5.73294 24.8787 -5.73297 24.8835 -5.73299 24.8882L0.000333364 24.9177ZM25.2351 0.000327088L25.2642 -5.733L25.264 -5.733L25.2351 0.000327088ZM25.1089 50.2168L25.0951 55.9502L25.1089 55.9502L25.1089 50.2168ZM5.73357 24.9614C5.81492 14.2804 14.525 5.67971 25.2061 5.73366L25.264 -5.733C8.26133 -5.81888 -5.60341 7.87194 -5.7329 24.874L5.73357 24.9614ZM25.206 5.73366C35.8873 5.78789 44.5099 14.476 44.483 25.157L55.9498 25.1858C55.9925 8.18307 42.2666 -5.64667 25.2642 -5.733L25.206 5.73366ZM44.483 25.157C44.4562 35.8384 35.7897 44.4834 25.1089 44.4834L25.1089 55.9502C42.1119 55.9502 55.9071 42.1883 55.9498 25.1858L44.483 25.157ZM25.1228 44.4834C22.5659 44.4772 20.0354 43.9666 17.6762 42.9808L13.2552 53.5612C17.0063 55.1285 21.0298 55.9404 25.0951 55.9502L25.1228 44.4834ZM17.6762 42.9808C15.317 41.9951 13.1754 40.5535 11.3743 38.7387L3.23546 46.8162C6.09922 49.7017 9.50417 51.9938 13.2552 53.5612L17.6762 42.9808ZM11.3743 38.7387C9.57316 36.9239 8.14781 34.7715 7.17989 32.4049L-3.43354 36.7458C-1.89457 40.5086 0.371705 43.9308 3.23546 46.8162L11.3743 38.7387ZM7.17989 32.4049C6.21196 30.0384 5.7205 27.504 5.73366 24.9472L-5.73299 24.8882C-5.75392 28.9535 -4.9725 32.983 -3.43354 36.7458L7.17989 32.4049Z",
                  stroke: "rgba(71,160,80,1)",
                  fillRule: "nonzero",
                  strokeLinejoin: "round",
                  strokeWidth: 11,
                },
                {
                  d: "M0.000333364 24.9177C0.105754 11.0761 11.3932 -0.0695834 25.2351 0.000327088C39.077 0.0706075 50.2512 11.3295 50.2164 25.1714C50.1816 39.0134 38.9508 50.2168 25.1089 50.2168C21.7978 50.2088 18.5208 49.5476 15.4657 48.271C12.4106 46.9944 9.63733 45.1276 7.30488 42.7775C4.97243 40.4273 3.12662 37.6401 1.87317 34.5754C0.619729 31.5107 -0.0167075 28.2288 0.000333364 24.9177Z",
                  fill: "rgba(71,160,80,1)",
                  fillRule: "evenodd",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="18.93%"
              bottom="61.44%"
              left="58.02%"
              right="22.44%"
              {...getOverrideProps(overrides, "Vector753724042")}
            ></Icon>
            <Icon
              width="100.43px"
              height="37.66px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 100.43289947509766,
                height: 37.66252899169922,
              }}
              paths={[
                {
                  d: "M0 31.3854L-5.7334 31.3854C-5.7334 31.3909 -5.73339 31.3964 -5.73338 31.4019L0 31.3854ZM0 25.1082L-5.73338 25.0914C-5.73339 25.097 -5.7334 25.1026 -5.7334 25.1082L0 25.1082ZM25.1082 0L25.1082 -5.7334C25.1026 -5.7334 25.097 -5.73339 25.0914 -5.73338L25.1082 0ZM75.3247 0L75.3415 -5.73338C75.3359 -5.73339 75.3303 -5.7334 75.3247 -5.7334L75.3247 0ZM100.433 25.1082L106.166 25.1082C106.166 25.1026 106.166 25.097 106.166 25.0914L100.433 25.1082ZM100.433 31.3854L106.166 31.4019C106.166 31.3964 106.166 31.3909 106.166 31.3854L100.433 31.3854ZM94.1558 37.6625L94.1558 43.3959C94.1615 43.3959 94.1672 43.3959 94.1729 43.3959L94.1558 37.6625ZM6.27715 37.6625L6.26 43.3959C6.26572 43.3959 6.27143 43.3959 6.27715 43.3959L6.27715 37.6625ZM5.7334 31.3854L5.7334 25.1082L-5.7334 25.1082L-5.7334 31.3854L5.7334 31.3854ZM5.73338 25.1251C5.7648 14.4283 14.4283 5.7648 25.1251 5.73338L25.0914 -5.73338C8.08803 -5.68342 -5.68342 8.08803 -5.73338 25.0914L5.73338 25.1251ZM25.1082 5.7334L75.3247 5.7334L75.3247 -5.7334L25.1082 -5.7334L25.1082 5.7334ZM75.3078 5.73338C86.0046 5.7648 94.6681 14.4283 94.6995 25.1251L106.166 25.0914C106.116 8.08803 92.3449 -5.68342 75.3415 -5.73338L75.3078 5.73338ZM94.6995 25.1082L94.6995 31.3854L106.166 31.3854L106.166 25.1082L94.6995 25.1082ZM94.6995 31.3689C94.6986 31.6774 94.4487 31.9282 94.1386 31.9292L94.1729 43.3959C100.788 43.3761 106.147 38.0186 106.166 31.4019L94.6995 31.3689ZM94.1558 31.9291L6.27715 31.9291L6.27715 43.3959L94.1558 43.3959L94.1558 31.9291ZM6.2943 31.9292C5.9842 31.9282 5.73427 31.6773 5.73338 31.3689L-5.73338 31.4019C-5.71429 38.0187 -0.355104 43.3761 6.26 43.3959L6.2943 31.9292Z",
                  stroke: "rgba(71,160,80,1)",
                  fillRule: "nonzero",
                  strokeLinejoin: "round",
                  strokeWidth: 11,
                },
                {
                  d: "M0 31.3854L0 25.1082C0.0406887 11.2582 11.2582 0.0406887 25.1082 0L75.3247 0C89.1747 0.0406887 100.392 11.2582 100.433 25.1082L100.433 31.3854C100.423 34.848 97.6184 37.6522 94.1558 37.6625L6.27715 37.6625C2.81455 37.6522 0.00998722 34.848 0 31.3854Z",
                  fill: "rgba(71,160,80,1)",
                  fillRule: "evenodd",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="48.29%"
              bottom="36.99%"
              left="48.26%"
              right="12.67%"
              {...getOverrideProps(overrides, "Vector753724043")}
            ></Icon>
            <Icon
              width="64.28px"
              height="110.86px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 64.27696990966797,
                height: 110.86363983154297,
              }}
              paths={[
                {
                  d: "M20.0658 4.05413C22.3049 1.81509 22.3049 -1.81509 20.0658 -4.05413C17.8268 -6.29316 14.1966 -6.29316 11.9576 -4.05413L20.0658 4.05413ZM5.06795 10.9438L1.01383 6.88964C-0.0613944 7.96486 -0.665448 9.42317 -0.665448 10.9438C-0.665447 12.4644 -0.0613941 13.9227 1.01383 14.9979L5.06795 10.9438ZM11.9576 25.9417C14.1966 28.1807 17.8268 28.1807 20.0659 25.9417C22.3049 23.7026 22.3049 20.0724 20.0658 17.8334L11.9576 25.9417ZM52.8971 -4.05413C50.6581 -6.29316 47.0279 -6.29316 44.7889 -4.05413C42.5499 -1.81509 42.5499 1.81509 44.7889 4.05413L52.8971 -4.05413ZM59.7868 10.9438L63.8409 14.9979C64.9161 13.9227 65.5202 12.4644 65.5202 10.9438C65.5202 9.42317 64.9161 7.96486 63.8409 6.88964L59.7868 10.9438ZM44.7889 17.8334C42.5499 20.0724 42.5499 23.7026 44.7889 25.9417C47.0279 28.1807 50.6581 28.1807 52.8971 25.9417L44.7889 17.8334ZM0 47.1903C-3.16647 47.1903 -5.7334 49.7573 -5.7334 52.9237C-5.7334 56.0902 -3.16647 58.6571 0 58.6571L0 47.1903ZM64.277 58.6571C67.4434 58.6571 70.0104 56.0902 70.0104 52.9237C70.0104 49.7573 67.4434 47.1903 64.277 47.1903L64.277 58.6571ZM0 76.1603C-3.16647 76.1603 -5.7334 78.7272 -5.7334 81.8937C-5.7334 85.0602 -3.16647 87.6271 0 87.6271L0 76.1603ZM64.277 87.6271C67.4434 87.6271 70.0104 85.0602 70.0104 81.8937C70.0104 78.7272 67.4434 76.1603 64.277 76.1603L64.277 87.6271ZM0 105.13C-3.16647 105.13 -5.7334 107.697 -5.7334 110.864C-5.7334 114.03 -3.16647 116.597 0 116.597L0 105.13ZM64.277 116.597C67.4434 116.597 70.0104 114.03 70.0104 110.864C70.0104 107.697 67.4434 105.13 64.277 105.13L64.277 116.597ZM11.9576 -4.05413L1.01383 6.88964L9.12208 14.9979L20.0658 4.05413L11.9576 -4.05413ZM1.01383 14.9979L11.9576 25.9417L20.0658 17.8334L9.12208 6.88964L1.01383 14.9979ZM44.7889 4.05413L55.7327 14.9979L63.8409 6.88964L52.8971 -4.05413L44.7889 4.05413ZM55.7327 6.88964L44.7889 17.8334L52.8971 25.9417L63.8409 14.9979L55.7327 6.88964ZM0 58.6571L64.277 58.6571L64.277 47.1903L0 47.1903L0 58.6571ZM0 87.6271L64.277 87.6271L64.277 76.1603L0 76.1603L0 87.6271ZM0 116.597L64.277 116.597L64.277 105.13L0 105.13L0 116.597Z",
                  stroke: "rgba(71,160,80,1)",
                  fillRule: "nonzero",
                  strokeLinejoin: "round",
                  strokeWidth: 11,
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="18.98%"
              bottom="37.7%"
              left="12.85%"
              right="62.14%"
              {...getOverrideProps(overrides, "Vector753724044")}
            ></Icon>
            <Flex
              gap="6.859082221984863px"
              direction="column"
              width="210.23px"
              height="54.19px"
              justifyContent="space-between"
              alignItems="flex-start"
              overflow="hidden"
              position="absolute"
              top="73.73%"
              bottom="5.09%"
              left="9.7%"
              right="8.49%"
              border="0.69px SOLID rgba(71,160,80,1)"
              borderRadius="2.7436325550079346px"
              padding="9.602714717388153px 16.664303958415985px 9.602714717388153px 16.664303958415985px"
              backgroundColor="rgba(255,255,255,1)"
              {...getOverrideProps(overrides, "Frame 427318909753724045")}
            >
              <Flex
                gap="4.801357269287109px"
                direction="row"
                width="unset"
                height="unset"
                justifyContent="center"
                alignItems="center"
                shrink="0"
                position="relative"
                padding="0px 0px 0px 0px"
                {...getOverrideProps(overrides, "Frame 427318911753724046")}
              >
                <Text
                  fontFamily="Inter"
                  fontSize="22.634971618652344px"
                  fontWeight="700"
                  color="rgba(0,0,0,1)"
                  lineHeight="33.952457427978516px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="98%"
                  {...getOverrideProps(overrides, "98%")}
                ></Text>
                <Flex
                  gap="6.859082221984863px"
                  direction="row"
                  width="unset"
                  height="unset"
                  justifyContent="center"
                  alignItems="center"
                  shrink="0"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  {...getOverrideProps(overrides, "Frame 427318934753724048")}
                >
                  <Text
                    fontFamily="Inter"
                    fontSize="13.718164443969727px"
                    fontWeight="600"
                    color="rgba(0,0,0,1)"
                    lineHeight="14.884208679199219px"
                    textAlign="left"
                    display="block"
                    direction="column"
                    justifyContent="unset"
                    width="unset"
                    height="unset"
                    gap="unset"
                    alignItems="unset"
                    shrink="0"
                    position="relative"
                    padding="0px 0px 0px 0px"
                    whiteSpace="pre-wrap"
                    children="Match"
                    {...getOverrideProps(overrides, "Match753724049")}
                  ></Text>
                  <Flex
                    gap="6.859082221984863px"
                    direction="row"
                    width="unset"
                    height="unset"
                    justifyContent="center"
                    alignItems="center"
                    overflow="hidden"
                    shrink="0"
                    position="relative"
                    borderRadius="4.801357269287109px"
                    padding="1.3718162775039673px 5.487265110015869px 1.3718162775039673px 5.487265110015869px"
                    backgroundColor="rgba(71,160,80,1)"
                    {...getOverrideProps(overrides, "Frame 427318910753724050")}
                  >
                    <Text
                      fontFamily="Inter"
                      fontSize="13.718164443969727px"
                      fontWeight="600"
                      color="rgba(255,255,255,1)"
                      lineHeight="14.884208679199219px"
                      textAlign="left"
                      display="block"
                      direction="column"
                      justifyContent="unset"
                      width="unset"
                      height="unset"
                      gap="unset"
                      alignItems="unset"
                      shrink="0"
                      position="relative"
                      padding="0px 0px 0px 0px"
                      whiteSpace="pre-wrap"
                      children="Excellent"
                      {...getOverrideProps(overrides, "Excellent")}
                    ></Text>
                  </Flex>
                </Flex>
              </Flex>
            </Flex>
          </View>
          <View
            padding="0px 0px 0px 0px"
            width="25.09px"
            height="37.53px"
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="319.36px"
            left="175px"
            transformOrigin="top left"
            transform="rotate(-54.25deg)"
            {...getOverrideProps(overrides, "Group 135")}
          >
            <Icon
              width="24px"
              height="0px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 23.15603542327881,
                height: 6.308565616607666,
              }}
              paths={[
                {
                  d: "M1 -2C0.447715 -2 0 -1.55228 0 -1C0 -0.447715 0.447715 0 1 0L1 -2ZM23 0C23.5523 0 24 -0.447715 24 -1C24 -1.55228 23.5523 -2 23 -2L23 0ZM1 0L23 0L23 -2L1 -2L1 0Z",
                  stroke: "rgba(71,160,80,1)",
                  fillRule: "nonzero",
                  strokeWidth: 2,
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="0%"
              bottom="100%"
              left="23.71%"
              right="-19.36%"
              transformOrigin="top left"
              transform="rotate(39.01deg)"
              {...getOverrideProps(overrides, "Line 9753724053")}
            ></Icon>
            <Icon
              width="24px"
              height="0px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 16.899431705474854,
                height: 17.041395664215088,
              }}
              paths={[
                {
                  d: "M1 -2C0.447715 -2 0 -1.55228 0 -1C0 -0.447715 0.447715 0 1 0L1 -2ZM23 0C23.5523 0 24 -0.447715 24 -1C24 -1.55228 23.5523 -2 23 -2L23 0ZM1 0L23 0L23 -2L1 -2L1 0Z",
                  stroke: "rgba(71,160,80,1)",
                  fillRule: "nonzero",
                  strokeWidth: 2,
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="49.33%"
              bottom="50.67%"
              left="5.53%"
              right="-1.18%"
              transformOrigin="top left"
              transform="rotate(9.01deg)"
              {...getOverrideProps(overrides, "Line 10753724054")}
            ></Icon>
            <Icon
              width="24px"
              height="0px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 6.114639759063721,
                height: 23.20799732208252,
              }}
              paths={[
                {
                  d: "M1 -2C0.447715 -2 0 -1.55228 0 -1C0 -0.447715 0.447715 0 1 0L1 -2ZM23 0C23.5523 0 24 -0.447715 24 -1C24 -1.55228 23.5523 -2 23 -2L23 0ZM1 0L23 0L23 -2L1 -2L1 0Z",
                  stroke: "rgba(71,160,80,1)",
                  fillRule: "nonzero",
                  strokeWidth: 2,
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="100%"
              bottom="0%"
              left="0%"
              right="4.35%"
              transformOrigin="top left"
              transform="rotate(-20.99deg)"
              {...getOverrideProps(overrides, "Line 11753724055")}
            ></Icon>
          </View>
          <View
            padding="0px 0px 0px 0px"
            width="25.09px"
            height="37.53px"
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="26.54px"
            left="502.7px"
            transformOrigin="top left"
            transform="rotate(135deg)"
            {...getOverrideProps(overrides, "Group 136")}
          >
            <Icon
              width="24px"
              height="0px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 23.868802070617676,
                height: 2.506052613258362,
              }}
              paths={[
                {
                  d: "M1 -2C0.447715 -2 0 -1.55228 0 -1C0 -0.447715 0.447715 0 1 0L1 -2ZM23 0C23.5523 0 24 -0.447715 24 -1C24 -1.55228 23.5523 -2 23 -2L23 0ZM1 0L23 0L23 -2L1 -2L1 0Z",
                  stroke: "rgba(71,160,80,1)",
                  fillRule: "nonzero",
                  strokeWidth: 2,
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="0%"
              bottom="100%"
              left="23.71%"
              right="-19.37%"
              transformOrigin="top left"
              transform="rotate(39.01deg)"
              {...getOverrideProps(overrides, "Line 9753724057")}
            ></Icon>
            <Icon
              width="24px"
              height="0px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 19.417961597442627,
                height: 14.104705810546875,
              }}
              paths={[
                {
                  d: "M1 -2C0.447715 -2 0 -1.55228 0 -1C0 -0.447715 0.447715 0 1 0L1 -2ZM23 0C23.5523 0 24 -0.447715 24 -1C24 -1.55228 23.5523 -2 23 -2L23 0ZM1 0L23 0L23 -2L1 -2L1 0Z",
                  stroke: "rgba(71,160,80,1)",
                  fillRule: "nonzero",
                  strokeWidth: 2,
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="49.33%"
              bottom="50.67%"
              left="5.53%"
              right="-1.18%"
              transformOrigin="top left"
              transform="rotate(9.01deg)"
              {...getOverrideProps(overrides, "Line 10753724058")}
            ></Icon>
            <Icon
              width="24px"
              height="0px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 9.764095544815063,
                height: 21.924014568328857,
              }}
              paths={[
                {
                  d: "M1 -2C0.447715 -2 0 -1.55228 0 -1C0 -0.447715 0.447715 0 1 0L1 -2ZM23 0C23.5523 0 24 -0.447715 24 -1C24 -1.55228 23.5523 -2 23 -2L23 0ZM1 0L23 0L23 -2L1 -2L1 0Z",
                  stroke: "rgba(71,160,80,1)",
                  fillRule: "nonzero",
                  strokeWidth: 2,
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="100%"
              bottom="0%"
              left="0%"
              right="4.35%"
              transformOrigin="top left"
              transform="rotate(-20.99deg)"
              {...getOverrideProps(overrides, "Line 11753724059")}
            ></Icon>
          </View>
          <View
            width="189px"
            height="199px"
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            overflow="hidden"
            position="absolute"
            top="100px"
            left="0px"
            border="1px SOLID rgba(225,225,225,1)"
            borderRadius="8px"
            padding="0px 0px 0px 0px"
            backgroundColor="rgba(255,255,255,1)"
            {...getOverrideProps(overrides, "389 1")}
          >
            <Icon
              width="244.82px"
              height="163.22px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 244.82278442382812,
                height: 163.21519470214844,
              }}
              paths={[]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="0%"
              bottom="17.98%"
              left="0%"
              right="-29.54%"
              {...getOverrideProps(overrides, "Vector753724061")}
            ></Icon>
            <Icon
              width="30.35px"
              height="22.09px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 30.35285758972168,
                height: 22.09178924560547,
              }}
              paths={[
                {
                  d: "M9.9515 19.7567C18.331 24.7791 30.3529 20.1365 30.3529 20.1365C30.3529 20.1365 28.7808 7.35291 20.3965 2.33649C12.0167 -2.68564 0 1.9513 0 1.9513C0 1.9513 1.57176 14.7346 9.9515 19.7567Z",
                  fillRule: "nonzero",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="56.88%"
              bottom="32.02%"
              left="13.52%"
              right="70.42%"
              {...getOverrideProps(overrides, "Vector753724062")}
            ></Icon>
            <Icon
              width="7px"
              height="7px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 7.003564834594727,
                height: 7.0035600662231445,
              }}
              paths={[
                {
                  d: "M3.50178 7.00356C5.43576 7.00356 7.00357 5.43576 7.00357 3.50178C7.00357 1.5678 5.43576 0 3.50178 0C1.5678 0 0 1.5678 0 3.50178C0 5.43576 1.5678 7.00356 3.50178 7.00356Z",
                  fill: "rgba(179,179,179,1)",
                  fillRule: "nonzero",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="27.76%"
              bottom="68.72%"
              left="50.91%"
              right="45.38%"
              transformOrigin="top left"
              transform="rotate(180deg)"
              {...getOverrideProps(overrides, "Vector753724063")}
            ></Icon>
            <Icon
              width="7.88px"
              height="7.88px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 7.878946781158447,
                height: 7.878946781158447,
              }}
              paths={[
                {
                  d: "M3.93947 7.87895C6.11518 7.87895 7.87895 6.11519 7.87895 3.93948C7.87895 1.76377 6.11518 0 3.93947 0C1.76376 0 0 1.76377 0 3.93948C0 6.11519 1.76376 7.87895 3.93947 7.87895Z",
                  fill: "rgba(179,179,179,1)",
                  fillRule: "nonzero",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="39.45%"
              bottom="56.59%"
              left="40.35%"
              right="55.48%"
              transformOrigin="top left"
              transform="rotate(180deg)"
              {...getOverrideProps(overrides, "Vector753724064")}
            ></Icon>
            <Icon
              width="3.94px"
              height="3.94px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 3.9394707679748535,
                height: 3.9394707679748535,
              }}
              paths={[
                {
                  d: "M1.96974 3.93947C3.05759 3.93947 3.93947 3.05759 3.93947 1.96974C3.93947 0.881881 3.05759 0 1.96974 0C0.881881 0 0 0.881881 0 1.96974C0 3.05759 0.881881 3.93947 1.96974 3.93947Z",
                  fill: "rgba(225,228,229,1)",
                  fillRule: "nonzero",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="67.78%"
              bottom="30.24%"
              left="97.88%"
              right="0.04%"
              transformOrigin="top left"
              transform="rotate(180deg)"
              {...getOverrideProps(overrides, "Vector753724065")}
            ></Icon>
            <Icon
              width="5.69px"
              height="5.69px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 5.690225601196289,
                height: 5.690225601196289,
              }}
              paths={[
                {
                  d: "M2.84511 5.69023C4.41643 5.69023 5.69023 4.41643 5.69023 2.84511C5.69023 1.2738 4.41643 0 2.84511 0C1.2738 0 0 1.2738 0 2.84511C0 4.41643 1.2738 5.69023 2.84511 5.69023Z",
                  fill: "rgba(225,228,229,1)",
                  fillRule: "nonzero",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="57.06%"
              bottom="40.08%"
              left="25.49%"
              right="71.5%"
              transformOrigin="top left"
              transform="rotate(180deg)"
              {...getOverrideProps(overrides, "Vector753724066")}
            ></Icon>
            <Icon
              width="4.33px"
              height="4.33px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 4.330643177032471,
                height: 4.330643177032471,
              }}
              paths={[
                {
                  d: "M2.16532 4.33064C3.3612 4.33064 4.33064 3.3612 4.33064 2.16532C4.33064 0.969447 3.3612 0 2.16532 0C0.969447 0 0 0.969447 0 2.16532C0 3.3612 0.969447 4.33064 2.16532 4.33064Z",
                  fill: "rgba(225,228,229,1)",
                  fillRule: "nonzero",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="43.32%"
              bottom="54.51%"
              left="49.47%"
              right="48.24%"
              transformOrigin="top left"
              transform="rotate(180deg)"
              {...getOverrideProps(overrides, "Vector753724067")}
            ></Icon>
            <Icon
              width="4.81px"
              height="4.81px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 4.814847946166992,
                height: 4.814847946166992,
              }}
              paths={[
                {
                  d: "M2.40742 4.81485C3.73701 4.81485 4.81485 3.73701 4.81485 2.40742C4.81485 1.07784 3.73701 0 2.40742 0C1.07784 0 0 1.07784 0 2.40742C0 3.73701 1.07784 4.81485 2.40742 4.81485Z",
                  fill: "rgba(225,228,229,1)",
                  fillRule: "nonzero",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="16.57%"
              bottom="81.01%"
              left="93.92%"
              right="3.54%"
              transformOrigin="top left"
              transform="rotate(180deg)"
              {...getOverrideProps(overrides, "Vector753724068")}
            ></Icon>
            <Icon
              width="4.32px"
              height="4.32px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 5.295270426580828,
                height: 5.295270426584466,
              }}
              paths={[
                {
                  d: "M2.16179 4.32357C3.35571 4.32357 4.32357 3.35571 4.32357 2.16179C4.32357 0.967864 3.35571 0 2.16179 0C0.967864 0 0 0.967864 0 2.16179C0 3.35571 0.967864 4.32357 2.16179 4.32357Z",
                  fill: "rgba(225,228,229,1)",
                  fillRule: "nonzero",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="29.58%"
              bottom="68.24%"
              left="36.85%"
              right="60.87%"
              transformOrigin="top left"
              transform="rotate(75deg)"
              {...getOverrideProps(overrides, "Vector753724069")}
            ></Icon>
            <Icon
              width="5.75px"
              height="5.75px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 5.751703262329102,
                height: 5.751703262329102,
              }}
              paths={[
                {
                  d: "M2.87585 5.7517C4.46414 5.7517 5.7517 4.46414 5.7517 2.87585C5.7517 1.28756 4.46414 0 2.87585 0C1.28756 0 0 1.28756 0 2.87585C0 4.46414 1.28756 5.7517 2.87585 5.7517Z",
                  fill: "rgba(225,228,229,1)",
                  fillRule: "nonzero",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="12.14%"
              bottom="84.97%"
              left="61.12%"
              right="35.84%"
              transformOrigin="top left"
              transform="rotate(180deg)"
              {...getOverrideProps(overrides, "Vector753724070")}
            ></Icon>
            <Icon
              width="4.42px"
              height="3.54px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 4.4247636795043945,
                height: 3.53959321975708,
              }}
              paths={[
                {
                  d: "M2.21238 3.53959C3.43425 3.53959 4.42476 2.74723 4.42476 1.7698C4.42476 0.792365 3.43425 0 2.21238 0C0.990517 0 0 0.792365 0 1.7698C0 2.74723 0.990517 3.53959 2.21238 3.53959Z",
                  fill: "rgba(225,228,229,1)",
                  fillRule: "nonzero",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="48.88%"
              bottom="49.34%"
              left="106.18%"
              right="-8.52%"
              transformOrigin="top left"
              transform="rotate(180deg)"
              {...getOverrideProps(overrides, "Vector753724071")}
            ></Icon>
            <Icon
              width="9px"
              height="9px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 11.020986735878978,
                height: 11.020986735878978,
              }}
              paths={[
                {
                  d: "M4.4993 8.9986C6.98419 8.9986 8.9986 6.98419 8.9986 4.4993C8.9986 2.01441 6.98419 0 4.4993 0C2.01441 0 0 2.01441 0 4.4993C0 6.98419 2.01441 8.9986 4.4993 8.9986Z",
                  fill: "rgba(225,228,229,1)",
                  fillRule: "nonzero",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="21.58%"
              bottom="73.89%"
              left="77.52%"
              right="17.72%"
              transformOrigin="top left"
              transform="rotate(75deg)"
              {...getOverrideProps(overrides, "Vector753724072")}
            ></Icon>
            <Icon
              width="152.98px"
              height="56.82px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 152.975341796875,
                height: 56.817386627197266,
              }}
              paths={[
                {
                  d: "M148.964 0L149.021 0C149.364 4.85592 152.975 4.93046 152.975 4.93046C152.975 4.93046 148.993 5.00826 148.993 10.619C148.993 5.00826 145.011 4.93046 145.011 4.93046C145.011 4.93046 148.621 4.85592 148.964 0ZM3.50695 47.2065L3.55837 47.2065C3.86249 51.6013 7.06667 51.669 7.06667 51.669C7.06667 51.669 3.53334 51.7392 3.53334 56.8174C3.53334 51.7392 0 51.669 0 51.669C0 51.669 3.20282 51.6013 3.50695 47.2065Z",
                  fill: "rgba(225,228,229,1)",
                  fillRule: "nonzero",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="43.63%"
              bottom="27.82%"
              left="35.07%"
              right="-16.01%"
              {...getOverrideProps(overrides, "Vector753724073")}
            ></Icon>
            <Icon
              width="36.93px"
              height="36.93px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 36.92964172363281,
                height: 36.92985534667969,
              }}
              paths={[
                {
                  d: "M0.000245159 18.3247L-4.21604 18.2926L-4.21609 18.303L0.000245159 18.3247ZM18.5581 0.000240544L18.5795 -4.2161L18.5794 -4.2161L18.5581 0.000240544ZM18.4653 36.9299L18.4552 41.1462L18.4653 41.1462L18.4653 36.9299ZM4.21652 18.3568C4.27634 10.5019 10.6818 4.17691 18.5368 4.21658L18.5794 -4.2161C6.07545 -4.27925 -4.1208 5.78909 -4.21603 18.2926L4.21652 18.3568ZM18.5367 4.21658C26.3918 4.25646 32.7329 10.6458 32.7132 18.5007L41.146 18.5219C41.1774 6.0179 31.0832 -4.15261 18.5795 -4.2161L18.5367 4.21658ZM32.7132 18.5007C32.6935 26.3558 26.3201 32.7135 18.4653 32.7135L18.4653 41.1462C30.9695 41.1462 41.1146 31.0257 41.146 18.5219L32.7132 18.5007ZM18.4755 32.7135C16.5952 32.7089 14.7342 32.3334 12.9992 31.6085L9.74801 39.3893C12.5066 40.542 15.4655 41.139 18.4552 41.1462L18.4755 32.7135ZM12.9992 31.6085C11.2642 30.8835 9.68933 29.8234 8.36476 28.4888L2.37939 34.4291C4.48542 36.5511 6.98945 38.2367 9.74801 39.3893L12.9992 31.6085ZM8.36476 28.4888C7.04019 27.1541 5.99197 25.5713 5.28015 23.8309L-2.52505 27.0232C-1.39328 29.7904 0.273355 32.307 2.37939 34.4291L8.36476 28.4888ZM5.28015 23.8309C4.56833 22.0905 4.2069 20.2267 4.21658 18.3464L-4.21609 18.303C-4.23148 21.2926 -3.65682 24.256 -2.52505 27.0232L5.28015 23.8309Z",
                  stroke: "rgba(179,179,179,1)",
                  fillRule: "nonzero",
                  strokeLinejoin: "round",
                  strokeWidth: 8,
                },
                {
                  d: "M0.000245159 18.3247C0.0777724 8.14549 8.37863 -0.0511722 18.5581 0.000240544C28.7375 0.0519253 36.9552 8.33183 36.9296 18.5113C36.904 28.6908 28.6448 36.9299 18.4653 36.9299C16.0303 36.924 13.6204 36.4377 11.3736 35.4989C9.12683 34.5601 7.08737 33.1872 5.37207 31.4589C3.65677 29.7306 2.29934 27.6808 1.37755 25.427C0.455754 23.1732 -0.0122868 20.7597 0.000245159 18.3247Z",
                  fill: "rgba(179,179,179,1)",
                  fillRule: "evenodd",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="17.91%"
              bottom="63.54%"
              left="58.02%"
              right="22.44%"
              {...getOverrideProps(overrides, "Vector753724074")}
            ></Icon>
            <Icon
              width="73.86px"
              height="27.7px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 73.85921478271484,
                height: 27.69734764099121,
              }}
              paths={[
                {
                  d: "M0 23.0811L-4.21641 23.0811L-4.21638 23.0932L0 23.0811ZM0 18.4648L-4.21639 18.4524L-4.21639 18.4648L0 18.4648ZM18.4648 0L18.4648 -4.21641L18.4524 -4.21637L18.4648 0ZM55.3944 0L55.4068 -4.21639L55.3944 -4.21639L55.3944 0ZM73.8592 18.4648L78.0756 18.4648L78.0756 18.4524L73.8592 18.4648ZM73.8592 23.0811L78.0756 23.0932L78.0756 23.0811L73.8592 23.0811ZM69.243 27.6973L69.243 31.9138L69.2556 31.9137L69.243 27.6973ZM4.61627 27.6973L4.60366 31.9137L4.61627 31.9137L4.61627 27.6973ZM4.21639 23.0811L4.21639 18.4648L-4.21639 18.4648L-4.21639 23.0811L4.21639 23.0811ZM4.21637 18.4772C4.23948 10.6107 10.6107 4.23948 18.4772 4.21637L18.4524 -4.21637C5.948 -4.17964 -4.17964 5.94801 -4.21637 18.4524L4.21637 18.4772ZM18.4648 4.21639L55.3944 4.21639L55.3944 -4.21639L18.4648 -4.21639L18.4648 4.21639ZM55.382 4.21637C63.2485 4.23948 69.6197 10.6107 69.6428 18.4772L78.0756 18.4524C78.0389 5.94801 67.9112 -4.17964 55.4068 -4.21637L55.382 4.21637ZM69.6428 18.4648L69.6428 23.0811L78.0756 23.0811L78.0756 18.4648L69.6428 18.4648ZM69.6428 23.0689C69.6422 23.2958 69.4584 23.4803 69.2303 23.481L69.2556 31.9137C74.1204 31.8992 78.0616 27.9592 78.0756 23.0932L69.6428 23.0689ZM69.243 23.481L4.61627 23.481L4.61627 31.9137L69.243 31.9137L69.243 23.481ZM4.62888 23.481C4.40083 23.4803 4.21703 23.2958 4.21638 23.0689L-4.21638 23.0932C-4.20234 27.9592 -0.261147 31.8992 4.60366 31.9137L4.62888 23.481Z",
                  stroke: "rgba(179,179,179,1)",
                  fillRule: "nonzero",
                  strokeLinejoin: "round",
                  strokeWidth: 8,
                },
                {
                  d: "M0 23.0811L0 18.4648C0.0299228 8.27936 8.27936 0.0299228 18.4648 0L55.3944 0C65.5799 0.0299228 73.8293 8.27936 73.8592 18.4648L73.8592 23.0811C73.8519 25.6275 71.7894 27.6897 69.243 27.6973L4.61627 27.6973C2.06984 27.6897 0.00734468 25.6275 0 23.0811Z",
                  fill: "rgba(179,179,179,1)",
                  fillRule: "evenodd",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="45.67%"
              bottom="40.41%"
              left="48.25%"
              right="12.67%"
              {...getOverrideProps(overrides, "Vector753724075")}
            ></Icon>
            <Icon
              width="47.27px"
              height="81.53px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 47.269832611083984,
                height: 81.53006744384766,
              }}
              paths={[
                {
                  d: "M14.7566 2.98144C16.4032 1.33484 16.4032 -1.33484 14.7566 -2.98144C13.11 -4.62804 10.4403 -4.62804 8.79372 -2.98144L14.7566 2.98144ZM3.72702 8.04814L0.745577 5.0667C-0.0451499 5.85743 -0.489376 6.92988 -0.489376 8.04814C-0.489376 9.1664 -0.0451497 10.2389 0.745578 11.0296L3.72702 8.04814ZM8.79372 19.0777C10.4403 20.7243 13.11 20.7243 14.7566 19.0777C16.4032 17.4311 16.4032 14.7614 14.7566 13.1148L8.79372 19.0777ZM38.901 -2.98144C37.2544 -4.62804 34.5847 -4.62804 32.9381 -2.98144C31.2915 -1.33484 31.2915 1.33484 32.9381 2.98144L38.901 -2.98144ZM43.9677 8.04814L46.9492 11.0296C47.7399 10.2389 48.1841 9.1664 48.1841 8.04814C48.1841 6.92988 47.7399 5.85743 46.9492 5.0667L43.9677 8.04814ZM32.9381 13.1148C31.2915 14.7614 31.2915 17.4311 32.9381 19.0777C34.5847 20.7243 37.2544 20.7243 38.901 19.0777L32.9381 13.1148ZM0 34.7042C-2.32865 34.7042 -4.21639 36.5919 -4.21639 38.9206C-4.21639 41.2492 -2.32865 43.137 0 43.137L0 34.7042ZM47.2698 43.137C49.5985 43.137 51.4862 41.2492 51.4862 38.9206C51.4862 36.5919 49.5985 34.7042 47.2698 34.7042L47.2698 43.137ZM0 56.0089C-2.32865 56.0089 -4.21639 57.8967 -4.21639 60.2253C-4.21639 62.554 -2.32865 64.4417 0 64.4417L0 56.0089ZM47.2698 64.4417C49.5985 64.4417 51.4862 62.554 51.4862 60.2253C51.4862 57.8967 49.5985 56.0089 47.2698 56.0089L47.2698 64.4417ZM0 77.3137C-2.32865 77.3137 -4.21639 79.2014 -4.21639 81.5301C-4.21639 83.8587 -2.32865 85.7465 0 85.7465L0 77.3137ZM47.2698 85.7465C49.5985 85.7465 51.4862 83.8587 51.4862 81.5301C51.4862 79.2014 49.5985 77.3137 47.2698 77.3137L47.2698 85.7465ZM8.79372 -2.98144L0.745577 5.0667L6.70846 11.0296L14.7566 2.98144L8.79372 -2.98144ZM0.745578 11.0296L8.79372 19.0777L14.7566 13.1148L6.70846 5.0667L0.745578 11.0296ZM32.9381 2.98144L40.9863 11.0296L46.9492 5.0667L38.901 -2.98144L32.9381 2.98144ZM40.9863 5.0667L32.9381 13.1148L38.901 19.0777L46.9492 11.0296L40.9863 5.0667ZM0 43.137L47.2698 43.137L47.2698 34.7042L0 34.7042L0 43.137ZM0 64.4417L47.2698 64.4417L47.2698 56.0089L0 56.0089L0 64.4417ZM0 85.7465L47.2698 85.7465L47.2698 77.3137L0 77.3137L0 85.7465Z",
                  stroke: "rgba(179,179,179,1)",
                  fillRule: "nonzero",
                  strokeLinejoin: "round",
                  strokeWidth: 8,
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="17.95%"
              bottom="41.08%"
              left="12.85%"
              right="62.14%"
              {...getOverrideProps(overrides, "Vector753724076")}
            ></Icon>
            <Flex
              gap="5.044227600097656px"
              direction="column"
              width="154.61px"
              height="39.85px"
              justifyContent="space-between"
              alignItems="center"
              overflow="hidden"
              position="absolute"
              top="69.73%"
              bottom="10.24%"
              left="9.7%"
              right="8.49%"
              border="0.5px SOLID rgba(71,160,80,1)"
              borderRadius="2.017690896987915px"
              padding="7.061918675899506px 12.255072057247162px 7.061918675899506px 12.255072057247162px"
              backgroundColor="rgba(255,255,255,1)"
              {...getOverrideProps(overrides, "Frame 427318909753724077")}
            >
              <Flex
                gap="3.530959129333496px"
                direction="row"
                width="unset"
                height="unset"
                justifyContent="center"
                alignItems="center"
                shrink="0"
                position="relative"
                padding="0px 0px 0px 0px"
                {...getOverrideProps(overrides, "Frame 427318911753724078")}
              >
                <Text
                  fontFamily="Inter"
                  fontSize="16.645952224731445px"
                  fontWeight="700"
                  color="rgba(0,0,0,1)"
                  lineHeight="24.968929290771484px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="88%"
                  {...getOverrideProps(overrides, "88%")}
                ></Text>
                <Flex
                  gap="5.044227600097656px"
                  direction="row"
                  width="unset"
                  height="unset"
                  justifyContent="center"
                  alignItems="center"
                  shrink="0"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  {...getOverrideProps(overrides, "Frame 427318934753724080")}
                >
                  <Text
                    fontFamily="Inter"
                    fontSize="10.088455200195312px"
                    fontWeight="600"
                    color="rgba(0,0,0,1)"
                    lineHeight="10.945974349975586px"
                    textAlign="left"
                    display="block"
                    direction="column"
                    justifyContent="unset"
                    width="unset"
                    height="unset"
                    gap="unset"
                    alignItems="unset"
                    shrink="0"
                    position="relative"
                    padding="0px 0px 0px 0px"
                    whiteSpace="pre-wrap"
                    children="Match"
                    {...getOverrideProps(overrides, "Match753724081")}
                  ></Text>
                  <Flex
                    gap="5.044227600097656px"
                    direction="row"
                    width="unset"
                    height="unset"
                    justifyContent="center"
                    alignItems="center"
                    overflow="hidden"
                    shrink="0"
                    position="relative"
                    borderRadius="3.530959129333496px"
                    padding="1.0088454484939575px 4.03538179397583px 1.0088454484939575px 4.03538179397583px"
                    backgroundColor="rgba(71,160,80,1)"
                    {...getOverrideProps(overrides, "Frame 427318910753724082")}
                  >
                    <Text
                      fontFamily="Inter"
                      fontSize="10.088455200195312px"
                      fontWeight="600"
                      color="rgba(255,255,255,1)"
                      lineHeight="10.945974349975586px"
                      textAlign="left"
                      display="block"
                      direction="column"
                      justifyContent="unset"
                      width="unset"
                      height="unset"
                      gap="unset"
                      alignItems="unset"
                      shrink="0"
                      position="relative"
                      padding="0px 0px 0px 0px"
                      whiteSpace="pre-wrap"
                      children="Great"
                      {...getOverrideProps(overrides, "Great753724083")}
                    ></Text>
                  </Flex>
                </Flex>
              </Flex>
            </Flex>
          </View>
        </Flex>
        <Flex
          gap="24px"
          direction="column"
          width="507px"
          height="unset"
          justifyContent="flex-start"
          alignItems="flex-start"
          shrink="0"
          position="relative"
          padding="0px 0px 0px 0px"
          {...getOverrideProps(overrides, "Frame 1160464104")}
        >
          <Text
            fontFamily="Inter"
            fontSize="40px"
            fontWeight="700"
            color="rgba(11,20,31,1)"
            lineHeight="60px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="Everyone Agrees. "
            {...getOverrideProps(overrides, "Everyone Agrees.\u00A0")}
          ></Text>
          <Flex
            gap="24px"
            direction="column"
            width="507px"
            height="unset"
            justifyContent="flex-start"
            alignItems="flex-start"
            shrink="0"
            position="relative"
            padding="0px 0px 0px 0px"
            {...getOverrideProps(overrides, "Frame 1160464351")}
          >
            <Text
              fontFamily="Inter"
              fontSize="20px"
              fontWeight="400"
              color="rgba(13,26,38,1)"
              lineHeight="30px"
              textAlign="left"
              display="block"
              direction="column"
              justifyContent="unset"
              width="552px"
              height="unset"
              gap="unset"
              alignItems="unset"
              shrink="0"
              position="relative"
              padding="0px 0px 0px 0px"
              whiteSpace="pre-wrap"
              children="This Is Job Search Done Right. "
              {...getOverrideProps(overrides, "This Is Job Search Done Right.")}
            ></Text>
            <Flex
              gap="14px"
              direction="column"
              width="552px"
              height="unset"
              justifyContent="center"
              alignItems="flex-start"
              shrink="0"
              position="relative"
              padding="0px 0px 0px 0px"
              {...getOverrideProps(overrides, "Frame 1160464105")}
            >
              <Flex
                gap="16px"
                direction="row"
                width="unset"
                height="unset"
                justifyContent="flex-start"
                alignItems="center"
                shrink="0"
                position="relative"
                padding="0px 0px 0px 0px"
                {...getOverrideProps(overrides, "Frame 1160464114")}
              >
                <View
                  width="29.5px"
                  height="29.5px"
                  {...getOverrideProps(overrides, "Check753724223")}
                ></View>
                <Text
                  fontFamily="Inter"
                  fontSize="20px"
                  fontWeight="400"
                  color="rgba(13,26,38,1)"
                  lineHeight="30px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Effortless, Rewarding, Fast"
                  {...getOverrideProps(
                    overrides,
                    "Effortless, Rewarding, Fast"
                  )}
                ></Text>
              </Flex>
              <Icon
                width="507px"
                height="0px"
                viewBox={{ minX: 0, minY: 0, width: 507, height: 1 }}
                paths={[
                  {
                    d: "M0 0.5L507 0.5L507 -0.5L0 -0.5L0 0.5Z",
                    stroke: "rgba(221,221,221,1)",
                    fillRule: "nonzero",
                    strokeWidth: 1,
                  },
                ]}
                display="block"
                gap="unset"
                alignItems="unset"
                justifyContent="unset"
                shrink="0"
                position="relative"
                {...getOverrideProps(overrides, "Line 3")}
              ></Icon>
              <Flex
                gap="10px"
                direction="row"
                width="unset"
                height="unset"
                justifyContent="center"
                alignItems="flex-start"
                shrink="0"
                position="relative"
                padding="0px 0px 0px 0px"
                {...getOverrideProps(overrides, "Frame 1160464115")}
              >
                <View
                  width="29.5px"
                  height="29.5px"
                  {...getOverrideProps(overrides, "Check753724227")}
                ></View>
                <Text
                  fontFamily="Inter"
                  fontSize="20px"
                  fontWeight="400"
                  color="rgba(13,26,38,1)"
                  lineHeight="30px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="We Search - You Approve "
                  {...getOverrideProps(overrides, "We Search - You Approve")}
                ></Text>
              </Flex>
              <Icon
                width="507px"
                height="0px"
                viewBox={{ minX: 0, minY: 0, width: 507, height: 1 }}
                paths={[
                  {
                    d: "M0 0.5L507 0.5L507 -0.5L0 -0.5L0 0.5Z",
                    stroke: "rgba(221,221,221,1)",
                    fillRule: "nonzero",
                    strokeWidth: 1,
                  },
                ]}
                display="block"
                gap="unset"
                alignItems="unset"
                justifyContent="unset"
                shrink="0"
                position="relative"
                {...getOverrideProps(overrides, "Line 2")}
              ></Icon>
              <Flex
                gap="10px"
                direction="row"
                width="unset"
                height="unset"
                justifyContent="center"
                alignItems="flex-start"
                shrink="0"
                position="relative"
                padding="0px 0px 0px 0px"
                {...getOverrideProps(overrides, "Frame 1160464116")}
              >
                <View
                  width="29.5px"
                  height="29.5px"
                  {...getOverrideProps(overrides, "Check753724231")}
                ></View>
                <Text
                  fontFamily="Inter"
                  fontSize="20px"
                  fontWeight="400"
                  color="rgba(13,26,38,1)"
                  lineHeight="30px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Results That You Can Trust "
                  {...getOverrideProps(
                    overrides,
                    "Results That You Can Trust\u00A0"
                  )}
                ></Text>
              </Flex>
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
}
